var items = {
  "block.minecraft.acacia_button": "Akacieknap",
  "block.minecraft.acacia_door": "Akaciedør",
  "block.minecraft.acacia_fence": "Akaciehegn",
  "block.minecraft.acacia_fence_gate": "Akaciehegnslåge",
  "block.minecraft.acacia_hanging_sign": "Hængende akacieskilt",
  "block.minecraft.acacia_leaves": "Akacieløv",
  "block.minecraft.acacia_log": "Akaciestamme",
  "block.minecraft.acacia_planks": "Akacieplanker",
  "block.minecraft.acacia_pressure_plate": "Akacietrykplade",
  "block.minecraft.acacia_sapling": "Ungt akacietræ",
  "block.minecraft.acacia_shelf": "Akaciehylde",
  "block.minecraft.acacia_sign": "Akacietræsskilt",
  "block.minecraft.acacia_slab": "Akacieplade",
  "block.minecraft.acacia_stairs": "Akacietrappe",
  "block.minecraft.acacia_trapdoor": "Akacielem",
  "block.minecraft.acacia_wall_hanging_sign": "Væghængende akacieskilt",
  "block.minecraft.acacia_wall_sign": "Akacietræsvægskilt",
  "block.minecraft.acacia_wood": "Akacietræ",
  "block.minecraft.activator_rail": "Aktiveringsspor",
  "block.minecraft.air": "Luft",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Blok af ametyst",
  "block.minecraft.amethyst_cluster": "Ametystklynge",
  "block.minecraft.ancient_debris": "Ældgamle stumper",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Andesitflise",
  "block.minecraft.andesite_stairs": "Andesittrappe",
  "block.minecraft.andesite_wall": "Andesitvæg",
  "block.minecraft.anvil": "Ambolt",
  "block.minecraft.attached_melon_stem": "Forbundet melonstilk",
  "block.minecraft.attached_pumpkin_stem": "Forbundet græskarstilk",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Azalealøv",
  "block.minecraft.azure_bluet": "Blå porcelænstjerne",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Blok af bambus",
  "block.minecraft.bamboo_button": "Bambusknap",
  "block.minecraft.bamboo_door": "Bambusdør",
  "block.minecraft.bamboo_fence": "Bambushegn",
  "block.minecraft.bamboo_fence_gate": "Bambushegnslåge",
  "block.minecraft.bamboo_hanging_sign": "Hængende bambusskilt",
  "block.minecraft.bamboo_mosaic": "Bambusmosaik",
  "block.minecraft.bamboo_mosaic_slab": "Bambus-mosaikflise",
  "block.minecraft.bamboo_mosaic_stairs": "Bambus-mosaiktrappe",
  "block.minecraft.bamboo_planks": "Bambusplanker",
  "block.minecraft.bamboo_pressure_plate": "Bambustrykplade",
  "block.minecraft.bamboo_sapling": "Bambus spirer",
  "block.minecraft.bamboo_shelf": "Bambushylde",
  "block.minecraft.bamboo_sign": "Bambusskilt",
  "block.minecraft.bamboo_slab": "Bambusflise",
  "block.minecraft.bamboo_stairs": "Bambustrappe",
  "block.minecraft.bamboo_trapdoor": "Bambuslem",
  "block.minecraft.bamboo_wall_hanging_sign": "Væghængende bambusskilt",
  "block.minecraft.bamboo_wall_sign": "Bambusvægskilt",
  "block.minecraft.banner.base.black": "Helt sort felt",
  "block.minecraft.banner.base.blue": "Helt blåt felt",
  "block.minecraft.banner.base.brown": "Helt brunt felt",
  "block.minecraft.banner.base.cyan": "Helt turkis felt",
  "block.minecraft.banner.base.gray": "Helt gråt felt",
  "block.minecraft.banner.base.green": "Helt grønt felt",
  "block.minecraft.banner.base.light_blue": "Helt lyseblåt felt",
  "block.minecraft.banner.base.light_gray": "Helt lysegråt felt",
  "block.minecraft.banner.base.lime": "Helt limegrønt felt",
  "block.minecraft.banner.base.magenta": "Helt magenta felt",
  "block.minecraft.banner.base.orange": "Helt orange felt",
  "block.minecraft.banner.base.pink": "Helt lyserødt felt",
  "block.minecraft.banner.base.purple": "Helt lilla felt",
  "block.minecraft.banner.base.red": "Helt rødt felt",
  "block.minecraft.banner.base.white": "Helt hvidt felt",
  "block.minecraft.banner.base.yellow": "Helt gult felt",
  "block.minecraft.banner.border.black": "Sort ramme",
  "block.minecraft.banner.border.blue": "Blå ramme",
  "block.minecraft.banner.border.brown": "Brun ramme",
  "block.minecraft.banner.border.cyan": "Turkis ramme",
  "block.minecraft.banner.border.gray": "Grå ramme",
  "block.minecraft.banner.border.green": "Grøn ramme",
  "block.minecraft.banner.border.light_blue": "Lyseblå ramme",
  "block.minecraft.banner.border.light_gray": "Lysegrå ramme",
  "block.minecraft.banner.border.lime": "Limegrøn ramme",
  "block.minecraft.banner.border.magenta": "Magenta ramme",
  "block.minecraft.banner.border.orange": "Orange ramme",
  "block.minecraft.banner.border.pink": "Lyserød ramme",
  "block.minecraft.banner.border.purple": "Lilla ramme",
  "block.minecraft.banner.border.red": "Rød ramme",
  "block.minecraft.banner.border.white": "Hvid ramme",
  "block.minecraft.banner.border.yellow": "Gul ramme",
  "block.minecraft.banner.bricks.black": "Sort murstensmønster",
  "block.minecraft.banner.bricks.blue": "Blåt murstensmønster",
  "block.minecraft.banner.bricks.brown": "Brunt murstensmønster",
  "block.minecraft.banner.bricks.cyan": "Turkis murstensmønster",
  "block.minecraft.banner.bricks.gray": "Gråt murstensmønster",
  "block.minecraft.banner.bricks.green": "Grønt murstensmønster",
  "block.minecraft.banner.bricks.light_blue": "Lyseblåt murstensmønster",
  "block.minecraft.banner.bricks.light_gray": "Lysegråt murstensmønster",
  "block.minecraft.banner.bricks.lime": "Limegrønt murstensmønster",
  "block.minecraft.banner.bricks.magenta": "Magenta murstensmønster",
  "block.minecraft.banner.bricks.orange": "Orange murstensmønster",
  "block.minecraft.banner.bricks.pink": "Lyserødt murstensmønster",
  "block.minecraft.banner.bricks.purple": "Lilla murstensmønster",
  "block.minecraft.banner.bricks.red": "Rødt murstensmønster",
  "block.minecraft.banner.bricks.white": "Hvidt murstensmønster",
  "block.minecraft.banner.bricks.yellow": "Gult murstensmønster",
  "block.minecraft.banner.circle.black": "Sort cirkel",
  "block.minecraft.banner.circle.blue": "Blå cirkel",
  "block.minecraft.banner.circle.brown": "Brun cirkel",
  "block.minecraft.banner.circle.cyan": "Turkis cirkel",
  "block.minecraft.banner.circle.gray": "Grå cirkel",
  "block.minecraft.banner.circle.green": "Grøn cirkel",
  "block.minecraft.banner.circle.light_blue": "Lyseblå cirkel",
  "block.minecraft.banner.circle.light_gray": "Lyssegrå cirkel",
  "block.minecraft.banner.circle.lime": "Limegrøn cirkel",
  "block.minecraft.banner.circle.magenta": "Magenta cirkel",
  "block.minecraft.banner.circle.orange": "Orange cirkel",
  "block.minecraft.banner.circle.pink": "Lyserød cirkel",
  "block.minecraft.banner.circle.purple": "Lilla cirkel",
  "block.minecraft.banner.circle.red": "Rød cirkel",
  "block.minecraft.banner.circle.white": "Hvid cirkel",
  "block.minecraft.banner.circle.yellow": "Gul cirkel",
  "block.minecraft.banner.creeper.black": "Sort creepersymbol",
  "block.minecraft.banner.creeper.blue": "Blåt creepersymbol",
  "block.minecraft.banner.creeper.brown": "Brunt creepersymbol",
  "block.minecraft.banner.creeper.cyan": "Turkis creepersymbol",
  "block.minecraft.banner.creeper.gray": "Gråt creepersymbol",
  "block.minecraft.banner.creeper.green": "Grønt creepersymbol",
  "block.minecraft.banner.creeper.light_blue": "Lyseblåt creepersymbol",
  "block.minecraft.banner.creeper.light_gray": "Lysegråt creepersymbol",
  "block.minecraft.banner.creeper.lime": "Limegrønt creepersymbol",
  "block.minecraft.banner.creeper.magenta": "Magenta creepersymbol",
  "block.minecraft.banner.creeper.orange": "Orange creepersymbol",
  "block.minecraft.banner.creeper.pink": "Lyserødt creepersymbol",
  "block.minecraft.banner.creeper.purple": "Lilla creepersymbol",
  "block.minecraft.banner.creeper.red": "Rødt creepersymbol",
  "block.minecraft.banner.creeper.white": "Hvidt creepersymbol",
  "block.minecraft.banner.creeper.yellow": "Gult creepersymbol",
  "block.minecraft.banner.cross.black": "Sort kryds",
  "block.minecraft.banner.cross.blue": "Blåt kryds",
  "block.minecraft.banner.cross.brown": "Brunt kryds",
  "block.minecraft.banner.cross.cyan": "Turkis kryds",
  "block.minecraft.banner.cross.gray": "Gråt kryds",
  "block.minecraft.banner.cross.green": "Grønt kryds",
  "block.minecraft.banner.cross.light_blue": "Lyseblåt kryds",
  "block.minecraft.banner.cross.light_gray": "Lysegråt kryds",
  "block.minecraft.banner.cross.lime": "Limegrønt kryds",
  "block.minecraft.banner.cross.magenta": "Magenta kryds",
  "block.minecraft.banner.cross.orange": "Orange kryds",
  "block.minecraft.banner.cross.pink": "Lyserødt kryds",
  "block.minecraft.banner.cross.purple": "Lilla kryds",
  "block.minecraft.banner.cross.red": "Rødt kryds",
  "block.minecraft.banner.cross.white": "Hvidt kryds",
  "block.minecraft.banner.cross.yellow": "Gult kryds",
  "block.minecraft.banner.curly_border.black": "Sort takket ramme",
  "block.minecraft.banner.curly_border.blue": "Blå takket ramme",
  "block.minecraft.banner.curly_border.brown": "Brun takket ramme",
  "block.minecraft.banner.curly_border.cyan": "Turkis takket ramme",
  "block.minecraft.banner.curly_border.gray": "Grå takket ramme",
  "block.minecraft.banner.curly_border.green": "Grøn takket ramme",
  "block.minecraft.banner.curly_border.light_blue": "Lyseblå takket ramme",
  "block.minecraft.banner.curly_border.light_gray": "Lysegrå takket ramme",
  "block.minecraft.banner.curly_border.lime": "Limegrøn takket ramme",
  "block.minecraft.banner.curly_border.magenta": "Magenta takket ramme",
  "block.minecraft.banner.curly_border.orange": "Orange takket ramme",
  "block.minecraft.banner.curly_border.pink": "Lyserød takket ramme",
  "block.minecraft.banner.curly_border.purple": "Lilla takket ramme",
  "block.minecraft.banner.curly_border.red": "Rød takket ramme",
  "block.minecraft.banner.curly_border.white": "Hvid takket ramme",
  "block.minecraft.banner.curly_border.yellow": "Gul takket ramme",
  "block.minecraft.banner.diagonal_left.black": "Sort øvre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_left.blue": "Blå øvre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_left.brown": "Brun øvre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_left.cyan": "Turkis øvre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_left.gray": "Grå øvre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_left.green": "Grøn øvre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_left.light_blue": "Lyseblå øvre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_left.light_gray": "Lysegrå øvre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_left.lime": "Limegrøn øvre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta øvre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_left.orange": "Orange øvre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_left.pink": "Lyserød øvre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_left.purple": "Lilla øvre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_left.red": "Rød øvre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_left.white": "Hvid øvre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_left.yellow": "Gul øvre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_right.black": "Sort øvre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_right.blue": "Blå øvre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_right.brown": "Brun øvre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_right.cyan": "Turkis øvre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_right.gray": "Grå øvre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_right.green": "Grøn øvre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_right.light_blue": "Lyseblå øvre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_right.light_gray": "Lysegrå øvre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_right.lime": "Limegrøn øvre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta øvre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_right.orange": "Orange øvre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_right.pink": "Lyserød øvre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_right.purple": "Lilla øvre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_right.red": "Rød øvre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_right.white": "Hvid øvre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_right.yellow": "Gul øvre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_left.black": "Sort nedre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_left.blue": "Blå nedre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_left.brown": "Brun nedre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_left.cyan": "Turkis nedre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_left.gray": "Grå nedre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_left.green": "Grøn nedre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Lyseblå nedre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Lysegrå nedre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_left.lime": "Limegrøn nedre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta nedre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_left.orange": "Orange nedre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_left.pink": "Lyserød nedre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_left.purple": "Lilla nedre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_left.red": "Rød nedre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_left.white": "Hvid nedre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_left.yellow": "Gul nedre venstrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_right.black": "Sort nedre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_right.blue": "Blå nedre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_right.brown": "Brun nedre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_right.cyan": "Turkis nedre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_right.gray": "Grå nedre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_right.green": "Grøn nedre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Lyseblå nedre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Lysegrå nedre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_right.lime": "Limegrøn nedre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta nedre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_right.orange": "Orange nedre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_right.pink": "Lyserød nedre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_right.purple": "Lilla nedre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_right.red": "Rød nedre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_right.white": "Hvid nedre højrebåndshalvdel",
  "block.minecraft.banner.diagonal_up_right.yellow": "Gul nedre højrebåndshalvdel",
  "block.minecraft.banner.flow.black": "Sort hvirvel",
  "block.minecraft.banner.flow.blue": "Blå hvirvel",
  "block.minecraft.banner.flow.brown": "Brun hvirvel",
  "block.minecraft.banner.flow.cyan": "Turkis hvirvel",
  "block.minecraft.banner.flow.gray": "Grå hvirvel",
  "block.minecraft.banner.flow.green": "Grøn hvirvel",
  "block.minecraft.banner.flow.light_blue": "Lyseblå hvirvel",
  "block.minecraft.banner.flow.light_gray": "Lysegrå hvirvel",
  "block.minecraft.banner.flow.lime": "Limegrøn hvirvel",
  "block.minecraft.banner.flow.magenta": "Magenta hvirvel",
  "block.minecraft.banner.flow.orange": "Orange hvirvel",
  "block.minecraft.banner.flow.pink": "Lyserød hvirvel",
  "block.minecraft.banner.flow.purple": "Lilla hvirvel",
  "block.minecraft.banner.flow.red": "Rød hvirvel",
  "block.minecraft.banner.flow.white": "Hvid hvirvel",
  "block.minecraft.banner.flow.yellow": "Gul hvirvel",
  "block.minecraft.banner.flower.black": "Sort blomstersymbol",
  "block.minecraft.banner.flower.blue": "Blåt blomstersymbol",
  "block.minecraft.banner.flower.brown": "Brunt blomstersymbol",
  "block.minecraft.banner.flower.cyan": "Turkis blomstersymbol",
  "block.minecraft.banner.flower.gray": "Gråt blomstersymbol",
  "block.minecraft.banner.flower.green": "Grønt blomstersymbol",
  "block.minecraft.banner.flower.light_blue": "Lyseblåt blomstersymbol",
  "block.minecraft.banner.flower.light_gray": "Lysegråt blomstersymbol",
  "block.minecraft.banner.flower.lime": "Limegrønt blomstersymbol",
  "block.minecraft.banner.flower.magenta": "Magenta blomstersymbol",
  "block.minecraft.banner.flower.orange": "Orange blomstersymbol",
  "block.minecraft.banner.flower.pink": "Lyserødt blomstersymbol",
  "block.minecraft.banner.flower.purple": "Lilla blomstersymbol",
  "block.minecraft.banner.flower.red": "Rødt blomstersymbol",
  "block.minecraft.banner.flower.white": "Hvidt blomstersymbol",
  "block.minecraft.banner.flower.yellow": "Gult blomstersymbol",
  "block.minecraft.banner.globe.black": "Sort globus",
  "block.minecraft.banner.globe.blue": "Blå globus",
  "block.minecraft.banner.globe.brown": "Brun globus",
  "block.minecraft.banner.globe.cyan": "Turkis globus",
  "block.minecraft.banner.globe.gray": "Grå globus",
  "block.minecraft.banner.globe.green": "Grøn globus",
  "block.minecraft.banner.globe.light_blue": "Lyseblå globus",
  "block.minecraft.banner.globe.light_gray": "Lysegrå globus",
  "block.minecraft.banner.globe.lime": "Limegrøn globus",
  "block.minecraft.banner.globe.magenta": "Magenta globus",
  "block.minecraft.banner.globe.orange": "Orange globus",
  "block.minecraft.banner.globe.pink": "Lyserød globus",
  "block.minecraft.banner.globe.purple": "Lilla globus",
  "block.minecraft.banner.globe.red": "Rød globus",
  "block.minecraft.banner.globe.white": "Hvid globus",
  "block.minecraft.banner.globe.yellow": "Gul globus",
  "block.minecraft.banner.gradient.black": "Øvre faldne sort",
  "block.minecraft.banner.gradient.blue": "Øvre faldne brun",
  "block.minecraft.banner.gradient.brown": "Øvre faldne brun",
  "block.minecraft.banner.gradient.cyan": "Øvre faldne turkis",
  "block.minecraft.banner.gradient.gray": "Øvre faldne grå",
  "block.minecraft.banner.gradient.green": "Øvre faldne grøn",
  "block.minecraft.banner.gradient.light_blue": "Øvre faldne lyseblå",
  "block.minecraft.banner.gradient.light_gray": "Øvre faldne lysegrå",
  "block.minecraft.banner.gradient.lime": "Øvre faldne limegrøn",
  "block.minecraft.banner.gradient.magenta": "Øvre faldne magenta",
  "block.minecraft.banner.gradient.orange": "Øvre faldne orange",
  "block.minecraft.banner.gradient.pink": "Øvre faldne lyserød",
  "block.minecraft.banner.gradient.purple": "Øvre faldne lilla",
  "block.minecraft.banner.gradient.red": "Øvre faldne rød",
  "block.minecraft.banner.gradient.white": "Øvre faldne hvid",
  "block.minecraft.banner.gradient.yellow": "Øvre faldne gul",
  "block.minecraft.banner.gradient_up.black": "Nedre faldne sort",
  "block.minecraft.banner.gradient_up.blue": "Nedre faldne blå",
  "block.minecraft.banner.gradient_up.brown": "Nedre faldne brun",
  "block.minecraft.banner.gradient_up.cyan": "Nedre faldne turkis",
  "block.minecraft.banner.gradient_up.gray": "Nedre faldne grå",
  "block.minecraft.banner.gradient_up.green": "Nedre faldne grøn",
  "block.minecraft.banner.gradient_up.light_blue": "Nedre faldne lyseblå",
  "block.minecraft.banner.gradient_up.light_gray": "Nedre faldne lysegrå",
  "block.minecraft.banner.gradient_up.lime": "Nedre faldne limegrøn",
  "block.minecraft.banner.gradient_up.magenta": "Nedre faldne magenta",
  "block.minecraft.banner.gradient_up.orange": "Nedre faldne orange",
  "block.minecraft.banner.gradient_up.pink": "Nedre faldne lyserød",
  "block.minecraft.banner.gradient_up.purple": "Nedre faldne lilla",
  "block.minecraft.banner.gradient_up.red": "Nedre faldne rød",
  "block.minecraft.banner.gradient_up.white": "Nedre faldne hvid",
  "block.minecraft.banner.gradient_up.yellow": "Nedre faldne gul",
  "block.minecraft.banner.guster.black": "Sort vindvæsen",
  "block.minecraft.banner.guster.blue": "Blåt vindvæsen",
  "block.minecraft.banner.guster.brown": "Brunt vindvæsen",
  "block.minecraft.banner.guster.cyan": "Turkis vindvæsen",
  "block.minecraft.banner.guster.gray": "Gråt vindvæsen",
  "block.minecraft.banner.guster.green": "Grønt vindvæsen",
  "block.minecraft.banner.guster.light_blue": "Lyseblåt vindvæsen",
  "block.minecraft.banner.guster.light_gray": "Lysegråt vindvæsen",
  "block.minecraft.banner.guster.lime": "Limegrønt vindvæsen",
  "block.minecraft.banner.guster.magenta": "Magenta vindvæsen",
  "block.minecraft.banner.guster.orange": "Orange vindvæsen",
  "block.minecraft.banner.guster.pink": "Lyserødt vindvæsen",
  "block.minecraft.banner.guster.purple": "Lillat vindvæsen",
  "block.minecraft.banner.guster.red": "Rødt vindvæsen",
  "block.minecraft.banner.guster.white": "Hvidt vindvæsen",
  "block.minecraft.banner.guster.yellow": "Gult vindvæsen",
  "block.minecraft.banner.half_horizontal.black": "Sort øvre halvdel",
  "block.minecraft.banner.half_horizontal.blue": "Blå øvre halvdel",
  "block.minecraft.banner.half_horizontal.brown": "Brun øvre halvdel",
  "block.minecraft.banner.half_horizontal.cyan": "Turkis øvre halvdel",
  "block.minecraft.banner.half_horizontal.gray": "Grå øvre halvdel",
  "block.minecraft.banner.half_horizontal.green": "Grøn øvre halvdel",
  "block.minecraft.banner.half_horizontal.light_blue": "Lyseblå øvre halvdel",
  "block.minecraft.banner.half_horizontal.light_gray": "Lysegrå øvre halvdel",
  "block.minecraft.banner.half_horizontal.lime": "Limegrøn øvre halvdel",
  "block.minecraft.banner.half_horizontal.magenta": "Magenta øvre halvdel",
  "block.minecraft.banner.half_horizontal.orange": "Orange øvre halvdel",
  "block.minecraft.banner.half_horizontal.pink": "Lyserød øvre halvdel",
  "block.minecraft.banner.half_horizontal.purple": "Lilla øvre halvdel",
  "block.minecraft.banner.half_horizontal.red": "Rød øvre halvdel",
  "block.minecraft.banner.half_horizontal.white": "Hvid øvre halvdel",
  "block.minecraft.banner.half_horizontal.yellow": "Gul øvre halvdel",
  "block.minecraft.banner.half_horizontal_bottom.black": "Sort nedre halvdel",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blå nedre halvdel",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brun nedre halvdel",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Turkis nedre halvdel",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grå nedre halvdel",
  "block.minecraft.banner.half_horizontal_bottom.green": "Grøn nedre halvdel",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Lyseblå nedre halvdel",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Lysegrå nedre halvdel",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Limegrøn nedre halvdel",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magenta nedre halvdel",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Orange nedre halvdel",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Lyserød nedre halvdel",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Lilla nedre halvdel",
  "block.minecraft.banner.half_horizontal_bottom.red": "Rød nedre halvdel",
  "block.minecraft.banner.half_horizontal_bottom.white": "Hvid nedre halvdel",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Gul nedre halvdel",
  "block.minecraft.banner.half_vertical.black": "Sort venstreside",
  "block.minecraft.banner.half_vertical.blue": "Blå venstreside",
  "block.minecraft.banner.half_vertical.brown": "Brun venstreside",
  "block.minecraft.banner.half_vertical.cyan": "Turkis venstreside",
  "block.minecraft.banner.half_vertical.gray": "Grå venstreside",
  "block.minecraft.banner.half_vertical.green": "Grøn venstreside",
  "block.minecraft.banner.half_vertical.light_blue": "Lyseblå venstreside",
  "block.minecraft.banner.half_vertical.light_gray": "Lysegrå venstreside",
  "block.minecraft.banner.half_vertical.lime": "Limegrøn venstreside",
  "block.minecraft.banner.half_vertical.magenta": "Magenta venstreside",
  "block.minecraft.banner.half_vertical.orange": "Orange venstreside",
  "block.minecraft.banner.half_vertical.pink": "Lyserød venstreside",
  "block.minecraft.banner.half_vertical.purple": "Lilla venstreside",
  "block.minecraft.banner.half_vertical.red": "Rød venstreside",
  "block.minecraft.banner.half_vertical.white": "Hvid venstreside",
  "block.minecraft.banner.half_vertical.yellow": "Gul venstreside",
  "block.minecraft.banner.half_vertical_right.black": "Sort højre halvdel",
  "block.minecraft.banner.half_vertical_right.blue": "Blå højre halvdel",
  "block.minecraft.banner.half_vertical_right.brown": "Brun højre halvdel",
  "block.minecraft.banner.half_vertical_right.cyan": "Turkis højre halvdel",
  "block.minecraft.banner.half_vertical_right.gray": "Grå højre halvdel",
  "block.minecraft.banner.half_vertical_right.green": "Grøn højre halvdel",
  "block.minecraft.banner.half_vertical_right.light_blue": "Lyseblå højre halvdel",
  "block.minecraft.banner.half_vertical_right.light_gray": "Lysegrå højre halvdel",
  "block.minecraft.banner.half_vertical_right.lime": "Limegrøn højre halvdel",
  "block.minecraft.banner.half_vertical_right.magenta": "Magenta højre halvdel",
  "block.minecraft.banner.half_vertical_right.orange": "Orange højre halvdel",
  "block.minecraft.banner.half_vertical_right.pink": "Lyserød højre halvdel",
  "block.minecraft.banner.half_vertical_right.purple": "Lilla højre halvdel",
  "block.minecraft.banner.half_vertical_right.red": "Rød højre halvdel",
  "block.minecraft.banner.half_vertical_right.white": "Hvid højre halvdel",
  "block.minecraft.banner.half_vertical_right.yellow": "Gul højre halvdel",
  "block.minecraft.banner.mojang.black": "Sort ting",
  "block.minecraft.banner.mojang.blue": "Blå ting",
  "block.minecraft.banner.mojang.brown": "Brun ting",
  "block.minecraft.banner.mojang.cyan": "Turkis ting",
  "block.minecraft.banner.mojang.gray": "Grå ting",
  "block.minecraft.banner.mojang.green": "Grøn ting",
  "block.minecraft.banner.mojang.light_blue": "Lyseblå ting",
  "block.minecraft.banner.mojang.light_gray": "Lysegrå ting",
  "block.minecraft.banner.mojang.lime": "Limegrøn ting",
  "block.minecraft.banner.mojang.magenta": "Magenta ting",
  "block.minecraft.banner.mojang.orange": "Orange ting",
  "block.minecraft.banner.mojang.pink": "Lyserød ting",
  "block.minecraft.banner.mojang.purple": "Lilla ting",
  "block.minecraft.banner.mojang.red": "Rød ting",
  "block.minecraft.banner.mojang.white": "Hvid ting",
  "block.minecraft.banner.mojang.yellow": "Gul ting",
  "block.minecraft.banner.piglin.black": "Sort snude",
  "block.minecraft.banner.piglin.blue": "Blå snude",
  "block.minecraft.banner.piglin.brown": "Brun snude",
  "block.minecraft.banner.piglin.cyan": "Turkis snude",
  "block.minecraft.banner.piglin.gray": "Grå snude",
  "block.minecraft.banner.piglin.green": "Grøn snude",
  "block.minecraft.banner.piglin.light_blue": "Lyseblå snude",
  "block.minecraft.banner.piglin.light_gray": "Lysegrå snude",
  "block.minecraft.banner.piglin.lime": "Limegrøn snude",
  "block.minecraft.banner.piglin.magenta": "Magenta snude",
  "block.minecraft.banner.piglin.orange": "Orange snude",
  "block.minecraft.banner.piglin.pink": "Lyserød snude",
  "block.minecraft.banner.piglin.purple": "Lilla snude",
  "block.minecraft.banner.piglin.red": "Rød snude",
  "block.minecraft.banner.piglin.white": "Hvid snude",
  "block.minecraft.banner.piglin.yellow": "Gul snude",
  "block.minecraft.banner.rhombus.black": "Sort rombe",
  "block.minecraft.banner.rhombus.blue": "Blå rombe",
  "block.minecraft.banner.rhombus.brown": "Brun rombe",
  "block.minecraft.banner.rhombus.cyan": "Turkis rombe",
  "block.minecraft.banner.rhombus.gray": "Grå rombe",
  "block.minecraft.banner.rhombus.green": "Grøn rombe",
  "block.minecraft.banner.rhombus.light_blue": "Lyseblå rombe",
  "block.minecraft.banner.rhombus.light_gray": "Lysegrå rombe",
  "block.minecraft.banner.rhombus.lime": "Limegrøn rombe",
  "block.minecraft.banner.rhombus.magenta": "Magenta rombe",
  "block.minecraft.banner.rhombus.orange": "Orange rombe",
  "block.minecraft.banner.rhombus.pink": "Lyserød rombe",
  "block.minecraft.banner.rhombus.purple": "Lilla rombe",
  "block.minecraft.banner.rhombus.red": "Rød rombe",
  "block.minecraft.banner.rhombus.white": "Hvid rombe",
  "block.minecraft.banner.rhombus.yellow": "Gul rombe",
  "block.minecraft.banner.skull.black": "Sort kraniumsymbol",
  "block.minecraft.banner.skull.blue": "Blåt kraniumsymbol",
  "block.minecraft.banner.skull.brown": "Brunt kraniumsymbol",
  "block.minecraft.banner.skull.cyan": "Turkis kraniumsymbol",
  "block.minecraft.banner.skull.gray": "Gråt kraniumsymbol",
  "block.minecraft.banner.skull.green": "Grønt kraniumsymbol",
  "block.minecraft.banner.skull.light_blue": "Lyseblåt kraniumsymbol",
  "block.minecraft.banner.skull.light_gray": "Lysegråt kraniumsymbol",
  "block.minecraft.banner.skull.lime": "Limegrønt kraniumsymbol",
  "block.minecraft.banner.skull.magenta": "Magenta kraniumsymbol",
  "block.minecraft.banner.skull.orange": "Orange kraniumsymbol",
  "block.minecraft.banner.skull.pink": "Lyserødt kraniumsymbol",
  "block.minecraft.banner.skull.purple": "Lilla kraniumsymbol",
  "block.minecraft.banner.skull.red": "Rødt kraniumsymbol",
  "block.minecraft.banner.skull.white": "Hvidt kraniumsymbol",
  "block.minecraft.banner.skull.yellow": "Gult kraniumsymbol",
  "block.minecraft.banner.small_stripes.black": "Sort gitter",
  "block.minecraft.banner.small_stripes.blue": "Blåt gitter",
  "block.minecraft.banner.small_stripes.brown": "Brunt gitter",
  "block.minecraft.banner.small_stripes.cyan": "Turkis gitter",
  "block.minecraft.banner.small_stripes.gray": "Gråt gitter",
  "block.minecraft.banner.small_stripes.green": "Grønt gitter",
  "block.minecraft.banner.small_stripes.light_blue": "Lyseblåt gitter",
  "block.minecraft.banner.small_stripes.light_gray": "Lysegråt gitter",
  "block.minecraft.banner.small_stripes.lime": "Limegrønt gitter",
  "block.minecraft.banner.small_stripes.magenta": "Magenta gitter",
  "block.minecraft.banner.small_stripes.orange": "Orange gitter",
  "block.minecraft.banner.small_stripes.pink": "Lyserødt gitter",
  "block.minecraft.banner.small_stripes.purple": "Lilla gitter",
  "block.minecraft.banner.small_stripes.red": "Rødt gitter",
  "block.minecraft.banner.small_stripes.white": "Hvidt gitter",
  "block.minecraft.banner.small_stripes.yellow": "Gult gitter",
  "block.minecraft.banner.square_bottom_left.black": "Sort firkant nederst til venstre",
  "block.minecraft.banner.square_bottom_left.blue": "Blå firkant nederst til venstre",
  "block.minecraft.banner.square_bottom_left.brown": "Brun firkant nederst til venstre",
  "block.minecraft.banner.square_bottom_left.cyan": "Turkis firkant nederst til venstre",
  "block.minecraft.banner.square_bottom_left.gray": "Grå firkant nederst til venstre",
  "block.minecraft.banner.square_bottom_left.green": "Grøn firkant nederst til venstre",
  "block.minecraft.banner.square_bottom_left.light_blue": "Lyseblå firkant nederst til venstre",
  "block.minecraft.banner.square_bottom_left.light_gray": "Lysegrå firkant nederst til venstre",
  "block.minecraft.banner.square_bottom_left.lime": "Limegrøn firkant nederst til venstre",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenta firkant nederst til venstre",
  "block.minecraft.banner.square_bottom_left.orange": "Orange firkant nederst til venstre",
  "block.minecraft.banner.square_bottom_left.pink": "Lyserød firkant nederst til venstre",
  "block.minecraft.banner.square_bottom_left.purple": "Lilla firkant nederst til venstre",
  "block.minecraft.banner.square_bottom_left.red": "Rød firkant nederst til venstre",
  "block.minecraft.banner.square_bottom_left.white": "Hvid firkant nederst til venstre",
  "block.minecraft.banner.square_bottom_left.yellow": "Gul firkant nederst til venstre",
  "block.minecraft.banner.square_bottom_right.black": "Sort firkant nede til højre",
  "block.minecraft.banner.square_bottom_right.blue": "Blå firkant nede til højre",
  "block.minecraft.banner.square_bottom_right.brown": "Brun firkant nede til højre",
  "block.minecraft.banner.square_bottom_right.cyan": "Turkis firkant nede til højre",
  "block.minecraft.banner.square_bottom_right.gray": "Grå firkant nede til højre",
  "block.minecraft.banner.square_bottom_right.green": "Grøn firkant nede til højre",
  "block.minecraft.banner.square_bottom_right.light_blue": "Lyseblå firkant nede til højre",
  "block.minecraft.banner.square_bottom_right.light_gray": "Lysegrå firkant nede til højre",
  "block.minecraft.banner.square_bottom_right.lime": "Limegrøn firkant nede til højre",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenta firkant nede til højre",
  "block.minecraft.banner.square_bottom_right.orange": "Orange firkant nede til højre",
  "block.minecraft.banner.square_bottom_right.pink": "Lyserød firkant nede til højre",
  "block.minecraft.banner.square_bottom_right.purple": "Lilla firkant nede til højre",
  "block.minecraft.banner.square_bottom_right.red": "Rød firkant nede til højre",
  "block.minecraft.banner.square_bottom_right.white": "Hvid firkant nede til højre",
  "block.minecraft.banner.square_bottom_right.yellow": "Gul firkant nede til højre",
  "block.minecraft.banner.square_top_left.black": "Sort firkant oppe til venstre",
  "block.minecraft.banner.square_top_left.blue": "Blå firkant oppe til venstre",
  "block.minecraft.banner.square_top_left.brown": "Brun firkant oppe til venstre",
  "block.minecraft.banner.square_top_left.cyan": "Turkis firkant oppe til venstre",
  "block.minecraft.banner.square_top_left.gray": "Grå firkant oppe til venstre",
  "block.minecraft.banner.square_top_left.green": "Grøn firkant oppe til venstre",
  "block.minecraft.banner.square_top_left.light_blue": "Lyseblå firkant oppe til venstre",
  "block.minecraft.banner.square_top_left.light_gray": "Lysegrå firkant oppe til venstre",
  "block.minecraft.banner.square_top_left.lime": "Limegrøn firkant oppe til venstre",
  "block.minecraft.banner.square_top_left.magenta": "Magenta firkant oppe til venstre",
  "block.minecraft.banner.square_top_left.orange": "Orange firkant oppe til venstre",
  "block.minecraft.banner.square_top_left.pink": "Lyserød firkant oppe til venstre",
  "block.minecraft.banner.square_top_left.purple": "Lilla firkant oppe til venstre",
  "block.minecraft.banner.square_top_left.red": "Rød firkant oppe til venstre",
  "block.minecraft.banner.square_top_left.white": "Hvid firkant oppe til venstre",
  "block.minecraft.banner.square_top_left.yellow": "Gul firkant oppe til venstre",
  "block.minecraft.banner.square_top_right.black": "Sort firkant oppe til højre",
  "block.minecraft.banner.square_top_right.blue": "Blå firkant oppe til højre",
  "block.minecraft.banner.square_top_right.brown": "Brun firkant oppe til højre",
  "block.minecraft.banner.square_top_right.cyan": "Turkis firkant oppe til højre",
  "block.minecraft.banner.square_top_right.gray": "Grå firkant oppe til højre",
  "block.minecraft.banner.square_top_right.green": "Grøn firkant oppe til højre",
  "block.minecraft.banner.square_top_right.light_blue": "Lyseblå firkant oppe til højre",
  "block.minecraft.banner.square_top_right.light_gray": "Lysegrå firkant oppe til højre",
  "block.minecraft.banner.square_top_right.lime": "Limegrøn firkant oppe til højre",
  "block.minecraft.banner.square_top_right.magenta": "Magenta firkant oppe til højre",
  "block.minecraft.banner.square_top_right.orange": "Orange firkant oppe til højre",
  "block.minecraft.banner.square_top_right.pink": "Lyserød firkant oppe til højre",
  "block.minecraft.banner.square_top_right.purple": "Lilla firkant oppe til højre",
  "block.minecraft.banner.square_top_right.red": "Rød firkant oppe til højre",
  "block.minecraft.banner.square_top_right.white": "Hvid firkant oppe til højre",
  "block.minecraft.banner.square_top_right.yellow": "Gul firkant oppe til højre",
  "block.minecraft.banner.straight_cross.black": "Sort kors",
  "block.minecraft.banner.straight_cross.blue": "Blåt kors",
  "block.minecraft.banner.straight_cross.brown": "Brunt kors",
  "block.minecraft.banner.straight_cross.cyan": "Turkis kors",
  "block.minecraft.banner.straight_cross.gray": "Gråt kors",
  "block.minecraft.banner.straight_cross.green": "Grønt kors",
  "block.minecraft.banner.straight_cross.light_blue": "Lyseblåt kors",
  "block.minecraft.banner.straight_cross.light_gray": "Lysegråt kors",
  "block.minecraft.banner.straight_cross.lime": "Limefarvet kors",
  "block.minecraft.banner.straight_cross.magenta": "Magenta kors",
  "block.minecraft.banner.straight_cross.orange": "Orange kors",
  "block.minecraft.banner.straight_cross.pink": "Lyserødt kors",
  "block.minecraft.banner.straight_cross.purple": "Lilla kors",
  "block.minecraft.banner.straight_cross.red": "Rødt kors",
  "block.minecraft.banner.straight_cross.white": "Hvidt kors",
  "block.minecraft.banner.straight_cross.yellow": "Gult kors",
  "block.minecraft.banner.stripe_bottom.black": "Sort base",
  "block.minecraft.banner.stripe_bottom.blue": "Blå base",
  "block.minecraft.banner.stripe_bottom.brown": "Brun base",
  "block.minecraft.banner.stripe_bottom.cyan": "Turkis base",
  "block.minecraft.banner.stripe_bottom.gray": "Grå base",
  "block.minecraft.banner.stripe_bottom.green": "Grøn base",
  "block.minecraft.banner.stripe_bottom.light_blue": "Lyseblå base",
  "block.minecraft.banner.stripe_bottom.light_gray": "Lysegrå base",
  "block.minecraft.banner.stripe_bottom.lime": "Limegrøn base",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenta base",
  "block.minecraft.banner.stripe_bottom.orange": "Orange base",
  "block.minecraft.banner.stripe_bottom.pink": "Lyserød base",
  "block.minecraft.banner.stripe_bottom.purple": "Lilla base",
  "block.minecraft.banner.stripe_bottom.red": "Rød base",
  "block.minecraft.banner.stripe_bottom.white": "Hvid base",
  "block.minecraft.banner.stripe_bottom.yellow": "Gul base",
  "block.minecraft.banner.stripe_center.black": "Sort pæl",
  "block.minecraft.banner.stripe_center.blue": "Blå pæl",
  "block.minecraft.banner.stripe_center.brown": "Brun pæl",
  "block.minecraft.banner.stripe_center.cyan": "Turkis pæl",
  "block.minecraft.banner.stripe_center.gray": "Grå pæl",
  "block.minecraft.banner.stripe_center.green": "Grøn pæl",
  "block.minecraft.banner.stripe_center.light_blue": "Lyseblå pæl",
  "block.minecraft.banner.stripe_center.light_gray": "Lysegrå pæl",
  "block.minecraft.banner.stripe_center.lime": "Limegrøn pæl",
  "block.minecraft.banner.stripe_center.magenta": "Magenta pæl",
  "block.minecraft.banner.stripe_center.orange": "Orange pæl",
  "block.minecraft.banner.stripe_center.pink": "Lyserød pæl",
  "block.minecraft.banner.stripe_center.purple": "Lilla pæl",
  "block.minecraft.banner.stripe_center.red": "Rød pæl",
  "block.minecraft.banner.stripe_center.white": "Hvid pæl",
  "block.minecraft.banner.stripe_center.yellow": "Gul pæl",
  "block.minecraft.banner.stripe_downleft.black": "Sort højrebånd",
  "block.minecraft.banner.stripe_downleft.blue": "Blåt højrebånd",
  "block.minecraft.banner.stripe_downleft.brown": "Brunt højrebånd",
  "block.minecraft.banner.stripe_downleft.cyan": "Turkis højrebånd",
  "block.minecraft.banner.stripe_downleft.gray": "Gråt højrebånd",
  "block.minecraft.banner.stripe_downleft.green": "Grønt højrebånd",
  "block.minecraft.banner.stripe_downleft.light_blue": "Lyseblåt højrebånd",
  "block.minecraft.banner.stripe_downleft.light_gray": "Lysegråt højrebånd",
  "block.minecraft.banner.stripe_downleft.lime": "Limegrønt højrebånd",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta højrebånd",
  "block.minecraft.banner.stripe_downleft.orange": "Orange højrebånd",
  "block.minecraft.banner.stripe_downleft.pink": "Lyserødt højrebånd",
  "block.minecraft.banner.stripe_downleft.purple": "Lilla højrebånd",
  "block.minecraft.banner.stripe_downleft.red": "Rødt højrebånd",
  "block.minecraft.banner.stripe_downleft.white": "Hvidt højrebånd",
  "block.minecraft.banner.stripe_downleft.yellow": "Gult højrebånd",
  "block.minecraft.banner.stripe_downright.black": "Sort venstrebånd",
  "block.minecraft.banner.stripe_downright.blue": "Blåt venstrebånd",
  "block.minecraft.banner.stripe_downright.brown": "Brunt venstrebånd",
  "block.minecraft.banner.stripe_downright.cyan": "Turkis venstrebånd",
  "block.minecraft.banner.stripe_downright.gray": "Gråt venstrebånd",
  "block.minecraft.banner.stripe_downright.green": "Grønt venstrebånd",
  "block.minecraft.banner.stripe_downright.light_blue": "Lyseblåt venstrebånd",
  "block.minecraft.banner.stripe_downright.light_gray": "Lysegråt venstrebånd",
  "block.minecraft.banner.stripe_downright.lime": "Limegrønt venstrebånd",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta venstrebånd",
  "block.minecraft.banner.stripe_downright.orange": "Orange venstrebånd",
  "block.minecraft.banner.stripe_downright.pink": "Lyserødt venstrebånd",
  "block.minecraft.banner.stripe_downright.purple": "Lilla venstrebånd",
  "block.minecraft.banner.stripe_downright.red": "Rødt venstrebånd",
  "block.minecraft.banner.stripe_downright.white": "Hvidt venstrebånd",
  "block.minecraft.banner.stripe_downright.yellow": "Gult venstrebånd",
  "block.minecraft.banner.stripe_left.black": "Sort venstre pæl",
  "block.minecraft.banner.stripe_left.blue": "Blå venstre pæl",
  "block.minecraft.banner.stripe_left.brown": "Brun venstre pæl",
  "block.minecraft.banner.stripe_left.cyan": "Turkis venstre pæl",
  "block.minecraft.banner.stripe_left.gray": "Grå venstre pæl",
  "block.minecraft.banner.stripe_left.green": "Grøn venstre pæl",
  "block.minecraft.banner.stripe_left.light_blue": "Lyseblå venstre pæl",
  "block.minecraft.banner.stripe_left.light_gray": "Lysegrå venstre pæl",
  "block.minecraft.banner.stripe_left.lime": "Limegrøn venstre pæl",
  "block.minecraft.banner.stripe_left.magenta": "Magenta venstre pæl",
  "block.minecraft.banner.stripe_left.orange": "Orange venstre pæl",
  "block.minecraft.banner.stripe_left.pink": "Lyserød venstre pæl",
  "block.minecraft.banner.stripe_left.purple": "Lilla venstre pæl",
  "block.minecraft.banner.stripe_left.red": "Rød venstre pæl",
  "block.minecraft.banner.stripe_left.white": "Hvid venstre pæl",
  "block.minecraft.banner.stripe_left.yellow": "Gul venstre pæl",
  "block.minecraft.banner.stripe_middle.black": "Sort bjælke",
  "block.minecraft.banner.stripe_middle.blue": "Blå bjælke",
  "block.minecraft.banner.stripe_middle.brown": "Brun bjælke",
  "block.minecraft.banner.stripe_middle.cyan": "Turkis bjælke",
  "block.minecraft.banner.stripe_middle.gray": "Grå bjælke",
  "block.minecraft.banner.stripe_middle.green": "Grøn bjælke",
  "block.minecraft.banner.stripe_middle.light_blue": "Lyseblå bjælke",
  "block.minecraft.banner.stripe_middle.light_gray": "Lysegrå bjælke",
  "block.minecraft.banner.stripe_middle.lime": "Limegrøn bjælke",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta bjælke",
  "block.minecraft.banner.stripe_middle.orange": "Orange bjælke",
  "block.minecraft.banner.stripe_middle.pink": "Lyserød bjælke",
  "block.minecraft.banner.stripe_middle.purple": "Lilla bjælke",
  "block.minecraft.banner.stripe_middle.red": "Rød bjælke",
  "block.minecraft.banner.stripe_middle.white": "Hvid bjælke",
  "block.minecraft.banner.stripe_middle.yellow": "Gul bjælke",
  "block.minecraft.banner.stripe_right.black": "Sort højre pæl",
  "block.minecraft.banner.stripe_right.blue": "Blå højre pæl",
  "block.minecraft.banner.stripe_right.brown": "Brun højre pæl",
  "block.minecraft.banner.stripe_right.cyan": "Turkis højre pæl",
  "block.minecraft.banner.stripe_right.gray": "Grå højre pæl",
  "block.minecraft.banner.stripe_right.green": "Grøn højre pæl",
  "block.minecraft.banner.stripe_right.light_blue": "Lyseblå højre pæl",
  "block.minecraft.banner.stripe_right.light_gray": "Lysegrå højre pæl",
  "block.minecraft.banner.stripe_right.lime": "Limegrøn højre pæl",
  "block.minecraft.banner.stripe_right.magenta": "Magenta højre pæl",
  "block.minecraft.banner.stripe_right.orange": "Orange højre pæl",
  "block.minecraft.banner.stripe_right.pink": "Lyserød højre pæl",
  "block.minecraft.banner.stripe_right.purple": "Lilla højre pæl",
  "block.minecraft.banner.stripe_right.red": "Rød højre pæl",
  "block.minecraft.banner.stripe_right.white": "Hvid højre pæl",
  "block.minecraft.banner.stripe_right.yellow": "Gul højre pæl",
  "block.minecraft.banner.stripe_top.black": "Sort top",
  "block.minecraft.banner.stripe_top.blue": "Blå top",
  "block.minecraft.banner.stripe_top.brown": "Brun top",
  "block.minecraft.banner.stripe_top.cyan": "Turkis top",
  "block.minecraft.banner.stripe_top.gray": "Grå top",
  "block.minecraft.banner.stripe_top.green": "Grøn top",
  "block.minecraft.banner.stripe_top.light_blue": "Lyseblå top",
  "block.minecraft.banner.stripe_top.light_gray": "Lysegrå top",
  "block.minecraft.banner.stripe_top.lime": "Limegrøn top",
  "block.minecraft.banner.stripe_top.magenta": "Magenta top",
  "block.minecraft.banner.stripe_top.orange": "Orange top",
  "block.minecraft.banner.stripe_top.pink": "Pink top",
  "block.minecraft.banner.stripe_top.purple": "Lilla top",
  "block.minecraft.banner.stripe_top.red": "Rød top",
  "block.minecraft.banner.stripe_top.white": "Hvid top",
  "block.minecraft.banner.stripe_top.yellow": "Gul top",
  "block.minecraft.banner.triangle_bottom.black": "Sort nedre trekant",
  "block.minecraft.banner.triangle_bottom.blue": "Blå nedre trekant",
  "block.minecraft.banner.triangle_bottom.brown": "Brun nedre trekant",
  "block.minecraft.banner.triangle_bottom.cyan": "Turkis nedre trekant",
  "block.minecraft.banner.triangle_bottom.gray": "Grå nedre trekant",
  "block.minecraft.banner.triangle_bottom.green": "Grøn nedre trekant",
  "block.minecraft.banner.triangle_bottom.light_blue": "Lyseblå nedre trekant",
  "block.minecraft.banner.triangle_bottom.light_gray": "Lysegrå nedre trekant",
  "block.minecraft.banner.triangle_bottom.lime": "Limegrøn nedre trekant",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta nedre trekant",
  "block.minecraft.banner.triangle_bottom.orange": "Orange nedre trekant",
  "block.minecraft.banner.triangle_bottom.pink": "Lyserød nedre trekant",
  "block.minecraft.banner.triangle_bottom.purple": "Lilla nedre trekant",
  "block.minecraft.banner.triangle_bottom.red": "Rød nedre trekant",
  "block.minecraft.banner.triangle_bottom.white": "Hvid nedre trekant",
  "block.minecraft.banner.triangle_bottom.yellow": "Gul nedre trekant",
  "block.minecraft.banner.triangle_top.black": "Sort øvre trekant",
  "block.minecraft.banner.triangle_top.blue": "Blå øvre trekant",
  "block.minecraft.banner.triangle_top.brown": "Brun øvre trekant",
  "block.minecraft.banner.triangle_top.cyan": "Turkis øvre trekant",
  "block.minecraft.banner.triangle_top.gray": "Grå øvre trekant",
  "block.minecraft.banner.triangle_top.green": "Grøn øvre trekant",
  "block.minecraft.banner.triangle_top.light_blue": "Lyseblå øvre trekant",
  "block.minecraft.banner.triangle_top.light_gray": "Lysegrå øvre trekant",
  "block.minecraft.banner.triangle_top.lime": "Limegrøn øvre trekant",
  "block.minecraft.banner.triangle_top.magenta": "Magenta øvre trekant",
  "block.minecraft.banner.triangle_top.orange": "Orange øvre trekant",
  "block.minecraft.banner.triangle_top.pink": "Lyserød øvre trekant",
  "block.minecraft.banner.triangle_top.purple": "Lilla øvre trekant",
  "block.minecraft.banner.triangle_top.red": "Rød øvre trekant",
  "block.minecraft.banner.triangle_top.white": "Hvid øvre trekant",
  "block.minecraft.banner.triangle_top.yellow": "Gul øvre trekant",
  "block.minecraft.banner.triangles_bottom.black": "Sorte bundpigge",
  "block.minecraft.banner.triangles_bottom.blue": "Blå bundpigge",
  "block.minecraft.banner.triangles_bottom.brown": "Brune bundpigge",
  "block.minecraft.banner.triangles_bottom.cyan": "Turkis bundpigge",
  "block.minecraft.banner.triangles_bottom.gray": "Grå bundpigge",
  "block.minecraft.banner.triangles_bottom.green": "Grønne bundpigge",
  "block.minecraft.banner.triangles_bottom.light_blue": "Lyseblå bundpigge",
  "block.minecraft.banner.triangles_bottom.light_gray": "Lysegrå bundpigge",
  "block.minecraft.banner.triangles_bottom.lime": "Limegrønne bundpigge",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta bundpigge",
  "block.minecraft.banner.triangles_bottom.orange": "Orange bundpigge",
  "block.minecraft.banner.triangles_bottom.pink": "Lyserøde bundpigge",
  "block.minecraft.banner.triangles_bottom.purple": "Lilla bundpigge",
  "block.minecraft.banner.triangles_bottom.red": "Røde bundpigge",
  "block.minecraft.banner.triangles_bottom.white": "Hvide bundpigge",
  "block.minecraft.banner.triangles_bottom.yellow": "Gule bundpigge",
  "block.minecraft.banner.triangles_top.black": "Sorte toppigge",
  "block.minecraft.banner.triangles_top.blue": "Blå toppigge",
  "block.minecraft.banner.triangles_top.brown": "Brune toppigge",
  "block.minecraft.banner.triangles_top.cyan": "Turkis toppigge",
  "block.minecraft.banner.triangles_top.gray": "Grå toppigge",
  "block.minecraft.banner.triangles_top.green": "Grønne toppigge",
  "block.minecraft.banner.triangles_top.light_blue": "Lyseblå toppigge",
  "block.minecraft.banner.triangles_top.light_gray": "Lysegrå toppigge",
  "block.minecraft.banner.triangles_top.lime": "Limegrønne toppigge",
  "block.minecraft.banner.triangles_top.magenta": "Magenta toppigge",
  "block.minecraft.banner.triangles_top.orange": "Orange toppigge",
  "block.minecraft.banner.triangles_top.pink": "Lyserøde toppigge",
  "block.minecraft.banner.triangles_top.purple": "Lilla toppigge",
  "block.minecraft.banner.triangles_top.red": "Røde toppigge",
  "block.minecraft.banner.triangles_top.white": "Hvide toppigge",
  "block.minecraft.banner.triangles_top.yellow": "Gule toppigge",
  "block.minecraft.barrel": "Tønde",
  "block.minecraft.barrier": "Barriere",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Signallys",
  "block.minecraft.beacon.primary": "Primær kraft",
  "block.minecraft.beacon.secondary": "Sekundær kraft",
  "block.minecraft.bed.no_sleep": "Du kan kun sove om natten eller under tordenvejr",
  "block.minecraft.bed.not_safe": "Du kan ikke sove nu; der er monstre i nærheden",
  "block.minecraft.bed.obstructed": "Sengen er optaget",
  "block.minecraft.bed.occupied": "Denne seng er optaget",
  "block.minecraft.bed.too_far_away": "Du kan ikke sove nu; sengen er for langt væk",
  "block.minecraft.bedrock": "Grundfjeld",
  "block.minecraft.bee_nest": "Bikube",
  "block.minecraft.beehive": "Bistade",
  "block.minecraft.beetroots": "Rødbeder",
  "block.minecraft.bell": "Klokke",
  "block.minecraft.big_dripleaf": "Stort dryppeblad",
  "block.minecraft.big_dripleaf_stem": "Stor dryppebladsstilk",
  "block.minecraft.birch_button": "Birkeknap",
  "block.minecraft.birch_door": "Birkedør",
  "block.minecraft.birch_fence": "Birkehegn",
  "block.minecraft.birch_fence_gate": "Birkehegnslåge",
  "block.minecraft.birch_hanging_sign": "Hængende birkeskilt",
  "block.minecraft.birch_leaves": "Birkeløv",
  "block.minecraft.birch_log": "Birkestamme",
  "block.minecraft.birch_planks": "Birkeplanker",
  "block.minecraft.birch_pressure_plate": "Birketrykplade",
  "block.minecraft.birch_sapling": "Ungt birketræ",
  "block.minecraft.birch_shelf": "Birkehylde",
  "block.minecraft.birch_sign": "Birketræsskilt",
  "block.minecraft.birch_slab": "Birkeplade",
  "block.minecraft.birch_stairs": "Birketrappe",
  "block.minecraft.birch_trapdoor": "Birkelem",
  "block.minecraft.birch_wall_hanging_sign": "Væghængende birkeskilt",
  "block.minecraft.birch_wall_sign": "Birketræsvægskilt",
  "block.minecraft.birch_wood": "Birketræ",
  "block.minecraft.black_banner": "Sort banner",
  "block.minecraft.black_bed": "Sort seng",
  "block.minecraft.black_candle": "Sort stearinlys",
  "block.minecraft.black_candle_cake": "Kage med sort stearinlys",
  "block.minecraft.black_carpet": "Sort tæppe",
  "block.minecraft.black_concrete": "Sort beton",
  "block.minecraft.black_concrete_powder": "Sort betonpulver",
  "block.minecraft.black_glazed_terracotta": "Sort glaseret terrakotta",
  "block.minecraft.black_shulker_box": "Sort shulkerboks",
  "block.minecraft.black_stained_glass": "Sort farvet glas",
  "block.minecraft.black_stained_glass_pane": "Sort farvet glaspanel",
  "block.minecraft.black_terracotta": "Sort terrakotta",
  "block.minecraft.black_wool": "Sort uld",
  "block.minecraft.blackstone": "Sortsten",
  "block.minecraft.blackstone_slab": "Sortstensflise",
  "block.minecraft.blackstone_stairs": "Sortstenstrappe",
  "block.minecraft.blackstone_wall": "Sortstensvæg",
  "block.minecraft.blast_furnace": "Højovn",
  "block.minecraft.blue_banner": "Blåt banner",
  "block.minecraft.blue_bed": "Blå seng",
  "block.minecraft.blue_candle": "Blåt stearinlys",
  "block.minecraft.blue_candle_cake": "Kage med blåt stearinlys",
  "block.minecraft.blue_carpet": "Blåt tæppe",
  "block.minecraft.blue_concrete": "Blå beton",
  "block.minecraft.blue_concrete_powder": "Blåt betonpulver",
  "block.minecraft.blue_glazed_terracotta": "Blå glaseret terrakotta",
  "block.minecraft.blue_ice": "Blåis",
  "block.minecraft.blue_orchid": "Blå orkidé",
  "block.minecraft.blue_shulker_box": "Blå shulkerboks",
  "block.minecraft.blue_stained_glass": "Blåt farvet glas",
  "block.minecraft.blue_stained_glass_pane": "Blåt farvet glaspanel",
  "block.minecraft.blue_terracotta": "Blå terrakotta",
  "block.minecraft.blue_wool": "Blå uld",
  "block.minecraft.bone_block": "Ben blok",
  "block.minecraft.bookshelf": "Bogreol",
  "block.minecraft.brain_coral": "Hjernekoral",
  "block.minecraft.brain_coral_block": "Hjernekoralblok",
  "block.minecraft.brain_coral_fan": "Hjernekoralvifte",
  "block.minecraft.brain_coral_wall_fan": "Hjernekoralvægvifte",
  "block.minecraft.brewing_stand": "Bryggestand",
  "block.minecraft.brick_slab": "Murstensflise",
  "block.minecraft.brick_stairs": "Murstenstrappe",
  "block.minecraft.brick_wall": "Murstensvæg",
  "block.minecraft.bricks": "Mursten",
  "block.minecraft.brown_banner": "Brunt banner",
  "block.minecraft.brown_bed": "Brun seng",
  "block.minecraft.brown_candle": "Brunt stearinlys",
  "block.minecraft.brown_candle_cake": "Kage med brunt stearinlys",
  "block.minecraft.brown_carpet": "Brunt tæppe",
  "block.minecraft.brown_concrete": "Brun beton",
  "block.minecraft.brown_concrete_powder": "Brunt betonpulver",
  "block.minecraft.brown_glazed_terracotta": "Brun glaseret terrakotta",
  "block.minecraft.brown_mushroom": "Brun svamp",
  "block.minecraft.brown_mushroom_block": "Brun svampeblok",
  "block.minecraft.brown_shulker_box": "Brun shulkerboks",
  "block.minecraft.brown_stained_glass": "Brunt farvet glas",
  "block.minecraft.brown_stained_glass_pane": "Brunt farvet glaspanel",
  "block.minecraft.brown_terracotta": "Brun terrakotta",
  "block.minecraft.brown_wool": "Brun uld",
  "block.minecraft.bubble_column": "Boble søjle",
  "block.minecraft.bubble_coral": "Boblekoral",
  "block.minecraft.bubble_coral_block": "Boblekoralblok",
  "block.minecraft.bubble_coral_fan": "Boblekoralvifte",
  "block.minecraft.bubble_coral_wall_fan": "Boblekoralvægvifte",
  "block.minecraft.budding_amethyst": "Spirende ametyst",
  "block.minecraft.bush": "Busk",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusblomst",
  "block.minecraft.cake": "Kage",
  "block.minecraft.calcite": "Calcit",
  "block.minecraft.calibrated_sculk_sensor": "Kalibreret sculk-sensor",
  "block.minecraft.campfire": "Bål",
  "block.minecraft.candle": "Stearinlys",
  "block.minecraft.candle_cake": "Kage med stearinlys",
  "block.minecraft.carrots": "Gulerødder",
  "block.minecraft.cartography_table": "Kartografi bord",
  "block.minecraft.carved_pumpkin": "Udskåret græskar",
  "block.minecraft.cauldron": "Gryde",
  "block.minecraft.cave_air": "Grotteluft",
  "block.minecraft.cave_vines": "Grottelianer",
  "block.minecraft.cave_vines_plant": "Grottelian plante",
  "block.minecraft.chain": "Kæde",
  "block.minecraft.chain_command_block": "Kæde kommandoblok",
  "block.minecraft.cherry_button": "Kirsebærknap",
  "block.minecraft.cherry_door": "Kirsebærdør",
  "block.minecraft.cherry_fence": "Kirsebærhegn",
  "block.minecraft.cherry_fence_gate": "Kirsebærhegnslåge",
  "block.minecraft.cherry_hanging_sign": "Hængende kirsebærskilt",
  "block.minecraft.cherry_leaves": "Kirsebærløv",
  "block.minecraft.cherry_log": "Kirsebærstamme",
  "block.minecraft.cherry_planks": "Kirsebærplanker",
  "block.minecraft.cherry_pressure_plate": "Kirsebærtrykplade",
  "block.minecraft.cherry_sapling": "Ungt kirsebærtræ",
  "block.minecraft.cherry_shelf": "Kirsebærhylde",
  "block.minecraft.cherry_sign": "Kirsebærtræsskilt",
  "block.minecraft.cherry_slab": "Kirsebærplade",
  "block.minecraft.cherry_stairs": "Kirsebærtrappe",
  "block.minecraft.cherry_trapdoor": "Kirsebærlem",
  "block.minecraft.cherry_wall_hanging_sign": "Væghængende kirsebærskilt",
  "block.minecraft.cherry_wall_sign": "Kirsebærsvægskilt",
  "block.minecraft.cherry_wood": "Kirsebærtræ",
  "block.minecraft.chest": "Kiste",
  "block.minecraft.chipped_anvil": "Hakket ambolt",
  "block.minecraft.chiseled_bookshelf": "Mejslet bogreol",
  "block.minecraft.chiseled_copper": "Mejslet kobber",
  "block.minecraft.chiseled_deepslate": "Mejslet dybskifer",
  "block.minecraft.chiseled_nether_bricks": "Mejslet nethermursten",
  "block.minecraft.chiseled_polished_blackstone": "Mejslet poleret sortsten",
  "block.minecraft.chiseled_quartz_block": "Mejslet kvartsblok",
  "block.minecraft.chiseled_red_sandstone": "Mejslet rød sandsten",
  "block.minecraft.chiseled_resin_bricks": "Mejslet harpiksmursten",
  "block.minecraft.chiseled_sandstone": "Mejslet sandsten",
  "block.minecraft.chiseled_stone_bricks": "Mejslede stenmursten",
  "block.minecraft.chiseled_tuff": "Mejslet tuf",
  "block.minecraft.chiseled_tuff_bricks": "Mejslet tufmursten",
  "block.minecraft.chorus_flower": "Omkvædsblomst",
  "block.minecraft.chorus_plant": "Omkvædsplante",
  "block.minecraft.clay": "Ler",
  "block.minecraft.closed_eyeblossom": "Lukket øjeblomst",
  "block.minecraft.coal_block": "Blok af kul",
  "block.minecraft.coal_ore": "Kulmalm",
  "block.minecraft.coarse_dirt": "Groft jord",
  "block.minecraft.cobbled_deepslate": "Dybskiferbrosten",
  "block.minecraft.cobbled_deepslate_slab": "Dybskifer-brostensflise",
  "block.minecraft.cobbled_deepslate_stairs": "Dybskifer-brostenstrappe",
  "block.minecraft.cobbled_deepslate_wall": "Dybskifer-brostensvæg",
  "block.minecraft.cobblestone": "Brosten",
  "block.minecraft.cobblestone_slab": "Brostensflise",
  "block.minecraft.cobblestone_stairs": "Brostenstrappe",
  "block.minecraft.cobblestone_wall": "Brostensvæg",
  "block.minecraft.cobweb": "Spindelvæv",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Kommandoblok",
  "block.minecraft.comparator": "Redstone-komparator",
  "block.minecraft.composter": "Kompostbeholder",
  "block.minecraft.conduit": "Fløder",
  "block.minecraft.copper_bars": "Kobbertremmer",
  "block.minecraft.copper_block": "Blok af kobber",
  "block.minecraft.copper_bulb": "Kobberpære",
  "block.minecraft.copper_chain": "Kobberkæde",
  "block.minecraft.copper_chest": "Kobberkiste",
  "block.minecraft.copper_door": "Kobberdør",
  "block.minecraft.copper_golem_statue": "Kobbergolemstatue",
  "block.minecraft.copper_grate": "Kobberrist",
  "block.minecraft.copper_lantern": "Kobberlanterne",
  "block.minecraft.copper_ore": "Kobbermalm",
  "block.minecraft.copper_torch": "Kobberfakkel",
  "block.minecraft.copper_trapdoor": "Kobberlem",
  "block.minecraft.copper_wall_torch": "Kobbervægfakkel",
  "block.minecraft.cornflower": "Kornblomst",
  "block.minecraft.cracked_deepslate_bricks": "Revnede dybskifermursten",
  "block.minecraft.cracked_deepslate_tiles": "Revnede dybskiferfliser",
  "block.minecraft.cracked_nether_bricks": "Revnede nethermursten",
  "block.minecraft.cracked_polished_blackstone_bricks": "Revnede poleret sortsten-mursten",
  "block.minecraft.cracked_stone_bricks": "Revnede stenmursten",
  "block.minecraft.crafter": "Fabrikant",
  "block.minecraft.crafting_table": "Arbejdsbord",
  "block.minecraft.creaking_heart": "Knirkende hjerte",
  "block.minecraft.creeper_head": "Creeper-hoved",
  "block.minecraft.creeper_wall_head": "Creeper-væghoved",
  "block.minecraft.crimson_button": "Karmoisinknap",
  "block.minecraft.crimson_door": "Karmoisindør",
  "block.minecraft.crimson_fence": "Karmoisinhegn",
  "block.minecraft.crimson_fence_gate": "Karmoisinhegnslåge",
  "block.minecraft.crimson_fungus": "Karmoisinsvamp",
  "block.minecraft.crimson_hanging_sign": "Hængende karmoisinskilt",
  "block.minecraft.crimson_hyphae": "Karmoisinhyfer",
  "block.minecraft.crimson_nylium": "Karmoisin nylium",
  "block.minecraft.crimson_planks": "Karmoisinplanker",
  "block.minecraft.crimson_pressure_plate": "Karmoisintrykplade",
  "block.minecraft.crimson_roots": "Karmoisinrødder",
  "block.minecraft.crimson_shelf": "Karmoisinhylde",
  "block.minecraft.crimson_sign": "Karmoisinskilt",
  "block.minecraft.crimson_slab": "Karmoisinplade",
  "block.minecraft.crimson_stairs": "Karmoisintrappe",
  "block.minecraft.crimson_stem": "Karmoisinstilk",
  "block.minecraft.crimson_trapdoor": "Karmoisinlem",
  "block.minecraft.crimson_wall_hanging_sign": "Væghængende karmoisinskilt",
  "block.minecraft.crimson_wall_sign": "Karmoisinvægskilt",
  "block.minecraft.crying_obsidian": "Grædende obsidian",
  "block.minecraft.cut_copper": "Skåret kobber",
  "block.minecraft.cut_copper_slab": "Skåret kobberplade",
  "block.minecraft.cut_copper_stairs": "Skåret kobbertrappe",
  "block.minecraft.cut_red_sandstone": "Skåret rød sandsten",
  "block.minecraft.cut_red_sandstone_slab": "Skåret rød sandstensflise",
  "block.minecraft.cut_sandstone": "Skåret sandsten",
  "block.minecraft.cut_sandstone_slab": "Skåret sandstensflise",
  "block.minecraft.cyan_banner": "Turkis banner",
  "block.minecraft.cyan_bed": "Turkis seng",
  "block.minecraft.cyan_candle": "Turkis stearinlys",
  "block.minecraft.cyan_candle_cake": "Kage med turkis stearinlys",
  "block.minecraft.cyan_carpet": "Turkis tæppe",
  "block.minecraft.cyan_concrete": "Turkis beton",
  "block.minecraft.cyan_concrete_powder": "Turkis betonpulver",
  "block.minecraft.cyan_glazed_terracotta": "Turkis glaseret terrakotta",
  "block.minecraft.cyan_shulker_box": "Turkis shulkerboks",
  "block.minecraft.cyan_stained_glass": "Turkis farvet glas",
  "block.minecraft.cyan_stained_glass_pane": "Turkis farvet glaspanel",
  "block.minecraft.cyan_terracotta": "Turkis terrakotta",
  "block.minecraft.cyan_wool": "Turkis uld",
  "block.minecraft.damaged_anvil": "Beskadet ambolt",
  "block.minecraft.dandelion": "Mælkebøtte",
  "block.minecraft.dark_oak_button": "Mørk egeknap",
  "block.minecraft.dark_oak_door": "Mørk egetræsdør",
  "block.minecraft.dark_oak_fence": "Mørk egetræshegn",
  "block.minecraft.dark_oak_fence_gate": "Mørk egetræshegnslåge",
  "block.minecraft.dark_oak_hanging_sign": "Hængende mørk egetræsskilt",
  "block.minecraft.dark_oak_leaves": "Mørkt egeløv",
  "block.minecraft.dark_oak_log": "Mørk egestamme",
  "block.minecraft.dark_oak_planks": "Mørke egeplanker",
  "block.minecraft.dark_oak_pressure_plate": "Mørk egetrykplade",
  "block.minecraft.dark_oak_sapling": "Ungt mørkt egetræ",
  "block.minecraft.dark_oak_shelf": "Mørk egehylde",
  "block.minecraft.dark_oak_sign": "Mørkt egetræsskilt",
  "block.minecraft.dark_oak_slab": "Mørk egeplade",
  "block.minecraft.dark_oak_stairs": "Mørke egetrappe",
  "block.minecraft.dark_oak_trapdoor": "Mørk egelem",
  "block.minecraft.dark_oak_wall_hanging_sign": "Væghængende mørk egetræsskilt",
  "block.minecraft.dark_oak_wall_sign": "Mørkt egetræsvægskilt",
  "block.minecraft.dark_oak_wood": "Mørk egetræ",
  "block.minecraft.dark_prismarine": "Mørk prismarine",
  "block.minecraft.dark_prismarine_slab": "Mørk prismarine-flise",
  "block.minecraft.dark_prismarine_stairs": "Mørk prismarine-trappe",
  "block.minecraft.daylight_detector": "Dagslysdetektor",
  "block.minecraft.dead_brain_coral": "Død hjernekoral",
  "block.minecraft.dead_brain_coral_block": "Død hjernekoralblok",
  "block.minecraft.dead_brain_coral_fan": "Død hjernekoralvifte",
  "block.minecraft.dead_brain_coral_wall_fan": "Død hjernekoralvægvifte",
  "block.minecraft.dead_bubble_coral": "Død boblekoral",
  "block.minecraft.dead_bubble_coral_block": "Død boblekoralblok",
  "block.minecraft.dead_bubble_coral_fan": "Død boblekoralvifte",
  "block.minecraft.dead_bubble_coral_wall_fan": "Død boblekoralvægvifte",
  "block.minecraft.dead_bush": "Død busk",
  "block.minecraft.dead_fire_coral": "Død ildkoral",
  "block.minecraft.dead_fire_coral_block": "Død ildkoralblok",
  "block.minecraft.dead_fire_coral_fan": "Død ildkoralvifte",
  "block.minecraft.dead_fire_coral_wall_fan": "Død ildkoralvægvifte",
  "block.minecraft.dead_horn_coral": "Død hornkoral",
  "block.minecraft.dead_horn_coral_block": "Død hornkoralblok",
  "block.minecraft.dead_horn_coral_fan": "Død hornkoralvifte",
  "block.minecraft.dead_horn_coral_wall_fan": "Død hornkoralvægvifte",
  "block.minecraft.dead_tube_coral": "Død orgelkoral",
  "block.minecraft.dead_tube_coral_block": "Død orgelkoralblok",
  "block.minecraft.dead_tube_coral_fan": "Død orgelkoralvifte",
  "block.minecraft.dead_tube_coral_wall_fan": "Død orgelkoralvægvifte",
  "block.minecraft.decorated_pot": "Dekoreret krukke",
  "block.minecraft.deepslate": "Dybskifer",
  "block.minecraft.deepslate_brick_slab": "Dybskifer-murstensflise",
  "block.minecraft.deepslate_brick_stairs": "Dybskifer-murstenstrappe",
  "block.minecraft.deepslate_brick_wall": "Dybskifer-murstensvæg",
  "block.minecraft.deepslate_bricks": "Dybskifermursten",
  "block.minecraft.deepslate_coal_ore": "Dybskiferkulmalm",
  "block.minecraft.deepslate_copper_ore": "Dybskiferkobbermalm",
  "block.minecraft.deepslate_diamond_ore": "Dybskiferdiamantmalm",
  "block.minecraft.deepslate_emerald_ore": "Dybskifersmaragdmalm",
  "block.minecraft.deepslate_gold_ore": "Dybskiferguldmalm",
  "block.minecraft.deepslate_iron_ore": "Dybskiferjernmalm",
  "block.minecraft.deepslate_lapis_ore": "Dybskifer-lapis lazulimalm",
  "block.minecraft.deepslate_redstone_ore": "Dybskifer-redstonemalm",
  "block.minecraft.deepslate_tile_slab": "Dybskifer-klinkeflise",
  "block.minecraft.deepslate_tile_stairs": "Dybskifer-klinketrappe",
  "block.minecraft.deepslate_tile_wall": "Dybskifer-klinkevæg",
  "block.minecraft.deepslate_tiles": "Dybskiferklinker",
  "block.minecraft.detector_rail": "Detektorspor",
  "block.minecraft.diamond_block": "Blok af diamant",
  "block.minecraft.diamond_ore": "Diamantmalm",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Dioritflise",
  "block.minecraft.diorite_stairs": "Diorittrappe",
  "block.minecraft.diorite_wall": "Dioritvæg",
  "block.minecraft.dirt": "Jord",
  "block.minecraft.dirt_path": "Jord sti",
  "block.minecraft.dispenser": "Automat",
  "block.minecraft.dragon_egg": "Drageæg",
  "block.minecraft.dragon_head": "Dragehoved",
  "block.minecraft.dragon_wall_head": "Drage-væghoved",
  "block.minecraft.dried_ghast": "Udtørret ghast",
  "block.minecraft.dried_kelp_block": "Tørret tangblok",
  "block.minecraft.dripstone_block": "Drypstenblok",
  "block.minecraft.dropper": "Udkaster",
  "block.minecraft.emerald_block": "Blok af smaragd",
  "block.minecraft.emerald_ore": "Smaragdmalm",
  "block.minecraft.enchanting_table": "Fortryllelsesbord",
  "block.minecraft.end_gateway": "End port",
  "block.minecraft.end_portal": "End portal",
  "block.minecraft.end_portal_frame": "End portalramme",
  "block.minecraft.end_rod": "Ender stang",
  "block.minecraft.end_stone": "End-sten",
  "block.minecraft.end_stone_brick_slab": "End-murstensflise",
  "block.minecraft.end_stone_brick_stairs": "End-murstenstrapper",
  "block.minecraft.end_stone_brick_wall": "End-murstensvæg",
  "block.minecraft.end_stone_bricks": "End-mursten",
  "block.minecraft.ender_chest": "Enderkiste",
  "block.minecraft.exposed_chiseled_copper": "Blotlagt mejlset kobber",
  "block.minecraft.exposed_copper": "Blotlagt kobber",
  "block.minecraft.exposed_copper_bars": "Blotlagt kobbertremmer",
  "block.minecraft.exposed_copper_bulb": "Blotlagt kobberpære",
  "block.minecraft.exposed_copper_chain": "Blotlagt kobberkæde",
  "block.minecraft.exposed_copper_chest": "Blotlagt kobberkiste",
  "block.minecraft.exposed_copper_door": "Blotlagt kobberdør",
  "block.minecraft.exposed_copper_golem_statue": "Blotlagt kobbergolemstatue",
  "block.minecraft.exposed_copper_grate": "Blotlagt kobberrist",
  "block.minecraft.exposed_copper_lantern": "Blotlagt kobberlanterne",
  "block.minecraft.exposed_copper_trapdoor": "Blotlagt kobberlem",
  "block.minecraft.exposed_cut_copper": "Blotlagt skåret kobber",
  "block.minecraft.exposed_cut_copper_slab": "Blotlagt skåret kobberplade",
  "block.minecraft.exposed_cut_copper_stairs": "Blotlagt skåret kobbertrappe",
  "block.minecraft.exposed_lightning_rod": "Blotlagt lynafleder",
  "block.minecraft.farmland": "Landbrugsjord",
  "block.minecraft.fern": "Bregne",
  "block.minecraft.fire": "Ild",
  "block.minecraft.fire_coral": "Ildkoral",
  "block.minecraft.fire_coral_block": "Ildkoralblok",
  "block.minecraft.fire_coral_fan": "Ildkoralvifte",
  "block.minecraft.fire_coral_wall_fan": "Ildkoralvægvifte",
  "block.minecraft.firefly_bush": "Ildflue busk",
  "block.minecraft.fletching_table": "Pilemager bord",
  "block.minecraft.flower_pot": "Blomsterkrukke",
  "block.minecraft.flowering_azalea": "Blomstrende azalea",
  "block.minecraft.flowering_azalea_leaves": "Blomstrende azalealøv",
  "block.minecraft.frogspawn": "Frøæg",
  "block.minecraft.frosted_ice": "Fortættet is",
  "block.minecraft.furnace": "Ovn",
  "block.minecraft.gilded_blackstone": "Forgyldt sortsten",
  "block.minecraft.glass": "Glas",
  "block.minecraft.glass_pane": "Glaspanel",
  "block.minecraft.glow_lichen": "Glødelav",
  "block.minecraft.glowstone": "Glødesten",
  "block.minecraft.gold_block": "Blok af guld",
  "block.minecraft.gold_ore": "Guldmalm",
  "block.minecraft.golden_dandelion": "Gylden mælkebøtte",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Granitflise",
  "block.minecraft.granite_stairs": "Granittrappe",
  "block.minecraft.granite_wall": "Granitvæg",
  "block.minecraft.grass": "Græs",
  "block.minecraft.grass_block": "Græsblok",
  "block.minecraft.gravel": "Grus",
  "block.minecraft.gray_banner": "Gråt banner",
  "block.minecraft.gray_bed": "Grå seng",
  "block.minecraft.gray_candle": "Gråt stearinlys",
  "block.minecraft.gray_candle_cake": "Kage med gråt stearinlys",
  "block.minecraft.gray_carpet": "Gråt tæppe",
  "block.minecraft.gray_concrete": "Grå beton",
  "block.minecraft.gray_concrete_powder": "Gråt betonpulver",
  "block.minecraft.gray_glazed_terracotta": "Grå glaseret terrakotta",
  "block.minecraft.gray_shulker_box": "Grå shulkerboks",
  "block.minecraft.gray_stained_glass": "Gråt farvet glas",
  "block.minecraft.gray_stained_glass_pane": "Gråt farvet glaspanel",
  "block.minecraft.gray_terracotta": "Grå terrakotta",
  "block.minecraft.gray_wool": "Grå uld",
  "block.minecraft.green_banner": "Grønt banner",
  "block.minecraft.green_bed": "Grøn seng",
  "block.minecraft.green_candle": "Grønt stearinlys",
  "block.minecraft.green_candle_cake": "Kage med grønt stearinlys",
  "block.minecraft.green_carpet": "Grønt tæppe",
  "block.minecraft.green_concrete": "Grøn beton",
  "block.minecraft.green_concrete_powder": "Grønt betonpulver",
  "block.minecraft.green_glazed_terracotta": "Grøn glaseret terrakotta",
  "block.minecraft.green_shulker_box": "Grøn shulkerboks",
  "block.minecraft.green_stained_glass": "Grønt farvet glas",
  "block.minecraft.green_stained_glass_pane": "Grønt farvet glaspanel",
  "block.minecraft.green_terracotta": "Grøn terrakotta",
  "block.minecraft.green_wool": "Grøn uld",
  "block.minecraft.grindstone": "Slibesten",
  "block.minecraft.hanging_roots": "Hængende rødder",
  "block.minecraft.hay_block": "Halmballe",
  "block.minecraft.heavy_core": "Tung kerne",
  "block.minecraft.heavy_weighted_pressure_plate": "Tungvægtet trykplade",
  "block.minecraft.honey_block": "Honningblok",
  "block.minecraft.honeycomb_block": "Bikageblok",
  "block.minecraft.hopper": "Tragt",
  "block.minecraft.horn_coral": "Hornkoral",
  "block.minecraft.horn_coral_block": "Hornkoralblok",
  "block.minecraft.horn_coral_fan": "Hornkoralvifte",
  "block.minecraft.horn_coral_wall_fan": "Hornkoralvægvifte",
  "block.minecraft.ice": "Is",
  "block.minecraft.infested_chiseled_stone_bricks": "Inficeret mejslet stenmursten",
  "block.minecraft.infested_cobblestone": "Inficeret brosten",
  "block.minecraft.infested_cracked_stone_bricks": "Inficeret revnede stenmursten",
  "block.minecraft.infested_deepslate": "Inficeret dybskifer",
  "block.minecraft.infested_mossy_stone_bricks": "Inficeret mosbegroede stenmursten",
  "block.minecraft.infested_stone": "Inficeret sten",
  "block.minecraft.infested_stone_bricks": "Inficeret stenmursten",
  "block.minecraft.iron_bars": "Jerntremmer",
  "block.minecraft.iron_block": "Blok af jern",
  "block.minecraft.iron_chain": "Jernkæde",
  "block.minecraft.iron_door": "Jerndør",
  "block.minecraft.iron_ore": "Jernmalm",
  "block.minecraft.iron_trapdoor": "Jernlem",
  "block.minecraft.jack_o_lantern": "Græskar lanterne",
  "block.minecraft.jigsaw": "Puslespils blok",
  "block.minecraft.jukebox": "Jukeboks",
  "block.minecraft.jungle_button": "Jungleknap",
  "block.minecraft.jungle_door": "Jungledør",
  "block.minecraft.jungle_fence": "Junglehegn",
  "block.minecraft.jungle_fence_gate": "Junglehegnslåge",
  "block.minecraft.jungle_hanging_sign": "Hængende jungleskilt",
  "block.minecraft.jungle_leaves": "Jungleløv",
  "block.minecraft.jungle_log": "Junglestamme",
  "block.minecraft.jungle_planks": "Jungleplanker",
  "block.minecraft.jungle_pressure_plate": "Jungletrykplade",
  "block.minecraft.jungle_sapling": "Ungt jungletræ",
  "block.minecraft.jungle_shelf": "Junglehylde",
  "block.minecraft.jungle_sign": "Jungletræsskilt",
  "block.minecraft.jungle_slab": "Jungleplade",
  "block.minecraft.jungle_stairs": "Jungletrappe",
  "block.minecraft.jungle_trapdoor": "Junglelem",
  "block.minecraft.jungle_wall_hanging_sign": "Væghængende jungleskilt",
  "block.minecraft.jungle_wall_sign": "Jungletræsvægskilt",
  "block.minecraft.jungle_wood": "Jungletræ",
  "block.minecraft.kelp": "Tang",
  "block.minecraft.kelp_plant": "Tangplante",
  "block.minecraft.ladder": "Stige",
  "block.minecraft.lantern": "Lanterne",
  "block.minecraft.lapis_block": "Blok af lapis lazuli",
  "block.minecraft.lapis_ore": "Lapis lazuli-malm",
  "block.minecraft.large_amethyst_bud": "Stor ametystknop",
  "block.minecraft.large_fern": "Stor bregne",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lavagryde",
  "block.minecraft.leaf_litter": "Førne",
  "block.minecraft.lectern": "Læsepult",
  "block.minecraft.lever": "Håndtag",
  "block.minecraft.light": "Lys",
  "block.minecraft.light_blue_banner": "Lyseblåt banner",
  "block.minecraft.light_blue_bed": "Lyseblå seng",
  "block.minecraft.light_blue_candle": "Lyseblåt stearinlys",
  "block.minecraft.light_blue_candle_cake": "Kage med lyseblåt stearinlys",
  "block.minecraft.light_blue_carpet": "Lyseblåt tæppe",
  "block.minecraft.light_blue_concrete": "Lyseblå beton",
  "block.minecraft.light_blue_concrete_powder": "Lyseblåt betonpulver",
  "block.minecraft.light_blue_glazed_terracotta": "Lyseblå glaseret terrakotta",
  "block.minecraft.light_blue_shulker_box": "Lyseblå shulkerboks",
  "block.minecraft.light_blue_stained_glass": "Lyseblåt farvet glas",
  "block.minecraft.light_blue_stained_glass_pane": "Lyseblåt farvet glaspanel",
  "block.minecraft.light_blue_terracotta": "Lyseblå terrakotta",
  "block.minecraft.light_blue_wool": "Lyseblå uld",
  "block.minecraft.light_gray_banner": "Lysegråt banner",
  "block.minecraft.light_gray_bed": "Lysegrå seng",
  "block.minecraft.light_gray_candle": "Lysegråt stearinlys",
  "block.minecraft.light_gray_candle_cake": "Kage med lysegråt stearinlys",
  "block.minecraft.light_gray_carpet": "Lysegråt tæppe",
  "block.minecraft.light_gray_concrete": "Lysegrå beton",
  "block.minecraft.light_gray_concrete_powder": "Lysegråt betonpulver",
  "block.minecraft.light_gray_glazed_terracotta": "Lysegrå glaseret terrakotta",
  "block.minecraft.light_gray_shulker_box": "Lysegrå shulkerboks",
  "block.minecraft.light_gray_stained_glass": "Lysegråt farvet glas",
  "block.minecraft.light_gray_stained_glass_pane": "Lysegråt farvet glaspanel",
  "block.minecraft.light_gray_terracotta": "Lysegrå terrakotta",
  "block.minecraft.light_gray_wool": "Lysegrå uld",
  "block.minecraft.light_weighted_pressure_plate": "Letvægtet trykplade",
  "block.minecraft.lightning_rod": "Lynafleder",
  "block.minecraft.lilac": "Syren",
  "block.minecraft.lily_of_the_valley": "Liljekonval",
  "block.minecraft.lily_pad": "Åkande",
  "block.minecraft.lime_banner": "Limegrønt banner",
  "block.minecraft.lime_bed": "Limegrøn seng",
  "block.minecraft.lime_candle": "Limegrønt stearinlys",
  "block.minecraft.lime_candle_cake": "Kage med limegrønt stearinlys",
  "block.minecraft.lime_carpet": "Limegrønt tæppe",
  "block.minecraft.lime_concrete": "Limegrøn beton",
  "block.minecraft.lime_concrete_powder": "Limegrønt betonpulver",
  "block.minecraft.lime_glazed_terracotta": "Limegrøn glaseret terrakotta",
  "block.minecraft.lime_shulker_box": "Limegrøn shulkerboks",
  "block.minecraft.lime_stained_glass": "Limegrønt farvet glas",
  "block.minecraft.lime_stained_glass_pane": "Limegrønt farvet glaspanel",
  "block.minecraft.lime_terracotta": "Limegrøn terrakotta",
  "block.minecraft.lime_wool": "Limegrønt uld",
  "block.minecraft.lodestone": "Ledesten",
  "block.minecraft.loom": "Væv",
  "block.minecraft.magenta_banner": "Magenta banner",
  "block.minecraft.magenta_bed": "Magenta seng",
  "block.minecraft.magenta_candle": "Magenta stearinlys",
  "block.minecraft.magenta_candle_cake": "Kage med magenta stearinlys",
  "block.minecraft.magenta_carpet": "Magenta tæppe",
  "block.minecraft.magenta_concrete": "Magenta beton",
  "block.minecraft.magenta_concrete_powder": "Magenta betonpulver",
  "block.minecraft.magenta_glazed_terracotta": "Magenta glaseret terrakotta",
  "block.minecraft.magenta_shulker_box": "Magenta shulkerboks",
  "block.minecraft.magenta_stained_glass": "Magenta farvet glas",
  "block.minecraft.magenta_stained_glass_pane": "Magenta farvet glaspanel",
  "block.minecraft.magenta_terracotta": "Magenta terrakotta",
  "block.minecraft.magenta_wool": "Magenta uld",
  "block.minecraft.magma_block": "Magmablok",
  "block.minecraft.mangrove_button": "Mangroveknap",
  "block.minecraft.mangrove_door": "Mangrovedør",
  "block.minecraft.mangrove_fence": "Mangrovehegn",
  "block.minecraft.mangrove_fence_gate": "Mangrovehegnslåge",
  "block.minecraft.mangrove_hanging_sign": "Hængende mangroveskilt",
  "block.minecraft.mangrove_leaves": "Mangroveløv",
  "block.minecraft.mangrove_log": "Mangrovestamme",
  "block.minecraft.mangrove_planks": "Mangroveplanker",
  "block.minecraft.mangrove_pressure_plate": "Mangrovetrykplade",
  "block.minecraft.mangrove_propagule": "Mangrove skud",
  "block.minecraft.mangrove_roots": "Mangroverødder",
  "block.minecraft.mangrove_shelf": "Mangrovehylde",
  "block.minecraft.mangrove_sign": "Mangrovetræsskilt",
  "block.minecraft.mangrove_slab": "Mangroveplade",
  "block.minecraft.mangrove_stairs": "Mangrovetrappe",
  "block.minecraft.mangrove_trapdoor": "Mangrovelem",
  "block.minecraft.mangrove_wall_hanging_sign": "Væghængende mangroveskilt",
  "block.minecraft.mangrove_wall_sign": "Mangrovetræsvægskilt",
  "block.minecraft.mangrove_wood": "Mangrovetræ",
  "block.minecraft.medium_amethyst_bud": "Medium ametystknop",
  "block.minecraft.melon": "Vandmelon",
  "block.minecraft.melon_stem": "Melonstilk",
  "block.minecraft.moss_block": "Mosblok",
  "block.minecraft.moss_carpet": "Mostæppe",
  "block.minecraft.mossy_cobblestone": "Mosbegroede brosten",
  "block.minecraft.mossy_cobblestone_slab": "Mosbegroet brostensflise",
  "block.minecraft.mossy_cobblestone_stairs": "Mosbegroet brostenstrappe",
  "block.minecraft.mossy_cobblestone_wall": "Mosbegroet brostensvæg",
  "block.minecraft.mossy_stone_brick_slab": "Mosbegroet stenmurstensflise",
  "block.minecraft.mossy_stone_brick_stairs": "Mosbegroet stenmurstenstrappe",
  "block.minecraft.mossy_stone_brick_wall": "Mosbegroet stenmurstensvæg",
  "block.minecraft.mossy_stone_bricks": "Mosbegroede stenmursten",
  "block.minecraft.moving_piston": "Bevægende stempel",
  "block.minecraft.mud": "Mudder",
  "block.minecraft.mud_brick_slab": "Mudder-murstensflise",
  "block.minecraft.mud_brick_stairs": "Mudder-murstenstrappe",
  "block.minecraft.mud_brick_wall": "Mudder-murstensvæg",
  "block.minecraft.mud_bricks": "Muddermursten",
  "block.minecraft.muddy_mangrove_roots": "Mudrede mangroverødder",
  "block.minecraft.mushroom_stem": "Svampestamme",
  "block.minecraft.mycelium": "Svampevæv",
  "block.minecraft.nether_brick_fence": "Nether-murstenshegn",
  "block.minecraft.nether_brick_slab": "Nether-murstensflise",
  "block.minecraft.nether_brick_stairs": "Nether-murstenstrappe",
  "block.minecraft.nether_brick_wall": "Nether-murstensvæg",
  "block.minecraft.nether_bricks": "Nethermursten",
  "block.minecraft.nether_gold_ore": "Nether guldmalm",
  "block.minecraft.nether_portal": "Netherportal",
  "block.minecraft.nether_quartz_ore": "Nether-kvartsmalm",
  "block.minecraft.nether_sprouts": "Nether spirer",
  "block.minecraft.nether_wart": "Nether-vorte",
  "block.minecraft.nether_wart_block": "Nether-vorteblok",
  "block.minecraft.netherite_block": "Blok af netherrit",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Nodeblok",
  "block.minecraft.oak_button": "Egeknap",
  "block.minecraft.oak_door": "Egetræsdør",
  "block.minecraft.oak_fence": "Egetræshegn",
  "block.minecraft.oak_fence_gate": "Egetræshegnslåge",
  "block.minecraft.oak_hanging_sign": "Hængende egeskilt",
  "block.minecraft.oak_leaves": "Egeløv",
  "block.minecraft.oak_log": "Egestamme",
  "block.minecraft.oak_planks": "Egeplanker",
  "block.minecraft.oak_pressure_plate": "Egetrykplade",
  "block.minecraft.oak_sapling": "Ungt egetræ",
  "block.minecraft.oak_shelf": "Egehylde",
  "block.minecraft.oak_sign": "Egetræsskilt",
  "block.minecraft.oak_slab": "Egeplade",
  "block.minecraft.oak_stairs": "Egetrappe",
  "block.minecraft.oak_trapdoor": "Egelem",
  "block.minecraft.oak_wall_hanging_sign": "Væghængende egeskilt",
  "block.minecraft.oak_wall_sign": "Egetræsvægskilt",
  "block.minecraft.oak_wood": "Egetræ",
  "block.minecraft.observer": "Observatør",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Okkerfarvet frølys",
  "block.minecraft.ominous_banner": "Ildevarslende banner",
  "block.minecraft.open_eyeblossom": "Åben øjeblomst",
  "block.minecraft.orange_banner": "Orange banner",
  "block.minecraft.orange_bed": "Orange seng",
  "block.minecraft.orange_candle": "Orange stearinlys",
  "block.minecraft.orange_candle_cake": "Kage med orange stearinlys",
  "block.minecraft.orange_carpet": "Orange tæppe",
  "block.minecraft.orange_concrete": "Orange beton",
  "block.minecraft.orange_concrete_powder": "Orange betonpulver",
  "block.minecraft.orange_glazed_terracotta": "Orange glaseret terrakotta",
  "block.minecraft.orange_shulker_box": "Orange shulkerboks",
  "block.minecraft.orange_stained_glass": "Orange farvet glas",
  "block.minecraft.orange_stained_glass_pane": "Orange farvet glaspanel",
  "block.minecraft.orange_terracotta": "Orange terrakotta",
  "block.minecraft.orange_tulip": "Orange tulipan",
  "block.minecraft.orange_wool": "Orange uld",
  "block.minecraft.oxeye_daisy": "Hvid okseøje",
  "block.minecraft.oxidized_chiseled_copper": "Oxideret mejslet kobber",
  "block.minecraft.oxidized_copper": "Oxideret kobber",
  "block.minecraft.oxidized_copper_bars": "Oxideret kobbertremmer",
  "block.minecraft.oxidized_copper_bulb": "Oxideret kobberpære",
  "block.minecraft.oxidized_copper_chain": "Oxideret kobberkæde",
  "block.minecraft.oxidized_copper_chest": "Oxideret kobberkiste",
  "block.minecraft.oxidized_copper_door": "Oxideret kobberdør",
  "block.minecraft.oxidized_copper_golem_statue": "Oxideret kobbergolemstatue",
  "block.minecraft.oxidized_copper_grate": "Oxideret kobberrist",
  "block.minecraft.oxidized_copper_lantern": "Oxideret kobberlanterne",
  "block.minecraft.oxidized_copper_trapdoor": "Oxideret kobberlem",
  "block.minecraft.oxidized_cut_copper": "Oxideret skåret kobber",
  "block.minecraft.oxidized_cut_copper_slab": "Oxideret skåret kobberplade",
  "block.minecraft.oxidized_cut_copper_stairs": "Oxideret skåret kobbertrappe",
  "block.minecraft.oxidized_lightning_rod": "Oxideret lynafleder",
  "block.minecraft.packed_ice": "Sammenpresset is",
  "block.minecraft.packed_mud": "Sammenpresset mudder",
  "block.minecraft.pale_hanging_moss": "Hængende blegt mos",
  "block.minecraft.pale_moss_block": "Bleg mosblok",
  "block.minecraft.pale_moss_carpet": "Blegt mostæppe",
  "block.minecraft.pale_oak_button": "Bleg egeknap",
  "block.minecraft.pale_oak_door": "Bleg egedør",
  "block.minecraft.pale_oak_fence": "Blegt egetræshegn",
  "block.minecraft.pale_oak_fence_gate": "Bleg egetræshegnslåge",
  "block.minecraft.pale_oak_hanging_sign": "Hængende blegt egetræsskilt",
  "block.minecraft.pale_oak_leaves": "Blegt egeløv",
  "block.minecraft.pale_oak_log": "Bleg egestamme",
  "block.minecraft.pale_oak_planks": "Blege egeplanker",
  "block.minecraft.pale_oak_pressure_plate": "Bleg egetrykplade",
  "block.minecraft.pale_oak_sapling": "Ungt blegt egetræ",
  "block.minecraft.pale_oak_shelf": "Bleg egehylde",
  "block.minecraft.pale_oak_sign": "Blegt egetræsskilt",
  "block.minecraft.pale_oak_slab": "Bleg egeplade",
  "block.minecraft.pale_oak_stairs": "Bleg egetrappe",
  "block.minecraft.pale_oak_trapdoor": "Bleg egelem",
  "block.minecraft.pale_oak_wall_hanging_sign": "Væghængende blegt egetræsskilt",
  "block.minecraft.pale_oak_wall_sign": "Blegt egetræsvægskilt",
  "block.minecraft.pale_oak_wood": "Blegt egetræ",
  "block.minecraft.pearlescent_froglight": "Perlelysende frølys",
  "block.minecraft.peony": "Pæon",
  "block.minecraft.petrified_oak_slab": "Forstenet egeplade",
  "block.minecraft.piglin_head": "Piglinhoved",
  "block.minecraft.piglin_wall_head": "Piglin-væghoved",
  "block.minecraft.pink_banner": "Lyserødt banner",
  "block.minecraft.pink_bed": "Lyserød seng",
  "block.minecraft.pink_candle": "Lyserødt stearinlys",
  "block.minecraft.pink_candle_cake": "Kage med lyserødt stearinlys",
  "block.minecraft.pink_carpet": "Lyserødt tæppe",
  "block.minecraft.pink_concrete": "Lyserød beton",
  "block.minecraft.pink_concrete_powder": "Lyserødt betonpulver",
  "block.minecraft.pink_glazed_terracotta": "Lyserød glaseret terrakotta",
  "block.minecraft.pink_petals": "Lyserøde kronblade",
  "block.minecraft.pink_shulker_box": "Lyserød shulkerboks",
  "block.minecraft.pink_stained_glass": "Lyserødt farvet glas",
  "block.minecraft.pink_stained_glass_pane": "Lyserødt farvet glaspanel",
  "block.minecraft.pink_terracotta": "Lyserød terrakotta",
  "block.minecraft.pink_tulip": "Lyserød tulipan",
  "block.minecraft.pink_wool": "Lyserød uld",
  "block.minecraft.piston": "Stempel",
  "block.minecraft.piston_head": "Stempelhoved",
  "block.minecraft.pitcher_crop": "Kandeafgrøde",
  "block.minecraft.pitcher_plant": "Kandeplante",
  "block.minecraft.player_head": "Spillerhoved",
  "block.minecraft.player_head.named": "%ss hoved",
  "block.minecraft.player_wall_head": "Spiller-væghoved",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Spids drypsten",
  "block.minecraft.polished_andesite": "Poleret andesit",
  "block.minecraft.polished_andesite_slab": "Poleret andesitflise",
  "block.minecraft.polished_andesite_stairs": "Poleret andesittrappe",
  "block.minecraft.polished_basalt": "Poleret basalt",
  "block.minecraft.polished_blackstone": "Poleret sortsten",
  "block.minecraft.polished_blackstone_brick_slab": "Poleret sortsten-murstensflise",
  "block.minecraft.polished_blackstone_brick_stairs": "Poleret sortsten-murstenstrappe",
  "block.minecraft.polished_blackstone_brick_wall": "Poleret sortsten-murstensvæg",
  "block.minecraft.polished_blackstone_bricks": "Poleret sortsten-mursten",
  "block.minecraft.polished_blackstone_button": "Poleret sortsten-knap",
  "block.minecraft.polished_blackstone_pressure_plate": "Poleret sortstenstrykplade",
  "block.minecraft.polished_blackstone_slab": "Poleret sortstensflise",
  "block.minecraft.polished_blackstone_stairs": "Poleret sortsten-trappe",
  "block.minecraft.polished_blackstone_wall": "Poleret sortsten-væg",
  "block.minecraft.polished_deepslate": "Poleret dybskifer",
  "block.minecraft.polished_deepslate_slab": "Poleret dybskiferflise",
  "block.minecraft.polished_deepslate_stairs": "Poleret dybskifertrappe",
  "block.minecraft.polished_deepslate_wall": "Poleret dybskifervæg",
  "block.minecraft.polished_diorite": "Poleret diorit",
  "block.minecraft.polished_diorite_slab": "Poleret dioritflise",
  "block.minecraft.polished_diorite_stairs": "Poleret diorittrappe",
  "block.minecraft.polished_granite": "Poleret granit",
  "block.minecraft.polished_granite_slab": "Poleret granitflise",
  "block.minecraft.polished_granite_stairs": "Poleret granittrappe",
  "block.minecraft.polished_tuff": "Poleret tuf",
  "block.minecraft.polished_tuff_slab": "Poleret tufplade",
  "block.minecraft.polished_tuff_stairs": "Poleret tuftrappe",
  "block.minecraft.polished_tuff_wall": "Poleret tufvæg",
  "block.minecraft.poppy": "Valmue",
  "block.minecraft.potatoes": "Kartofler",
  "block.minecraft.potted_acacia_sapling": "Ungt akacietræ potteplante",
  "block.minecraft.potted_allium": "Allium potteplante",
  "block.minecraft.potted_azalea_bush": "Azalea potteplante",
  "block.minecraft.potted_azure_bluet": "Blå porcelænstjerne potteplante",
  "block.minecraft.potted_bamboo": "Bambus potteplante",
  "block.minecraft.potted_birch_sapling": "Ungt birketræ potteplante",
  "block.minecraft.potted_blue_orchid": "Blå orkidé potteplante",
  "block.minecraft.potted_brown_mushroom": "Brun svamp potteplante",
  "block.minecraft.potted_cactus": "Kaktus potteplante",
  "block.minecraft.potted_cherry_sapling": "Ungt kirsebærtræ potteplante",
  "block.minecraft.potted_closed_eyeblossom": "Lukket øjenblomst potteplante",
  "block.minecraft.potted_cornflower": "Kornblomst potteplante",
  "block.minecraft.potted_crimson_fungus": "Karmoisinsvamp potteplante",
  "block.minecraft.potted_crimson_roots": "Karmoisinrødder potteplante",
  "block.minecraft.potted_dandelion": "Mælkebøtte potteplante",
  "block.minecraft.potted_dark_oak_sapling": "Ungt mørk egetræ potteplante",
  "block.minecraft.potted_dead_bush": "Død busk potteplante",
  "block.minecraft.potted_fern": "Bregne potteplante",
  "block.minecraft.potted_flowering_azalea_bush": "Blomstrende azalea potteplante",
  "block.minecraft.potted_golden_dandelion": "Gylden mælkebøtte potteplante",
  "block.minecraft.potted_jungle_sapling": "Ungt jungletræ potteplante",
  "block.minecraft.potted_lily_of_the_valley": "Liljekonval potteplante",
  "block.minecraft.potted_mangrove_propagule": "Mangrove skud potteplante",
  "block.minecraft.potted_oak_sapling": "Ungt egetræ potteplante",
  "block.minecraft.potted_open_eyeblossom": "Åben øjenblomst potteplante",
  "block.minecraft.potted_orange_tulip": "Orange tulipan potteplante",
  "block.minecraft.potted_oxeye_daisy": "Hvid okseøje potteplante",
  "block.minecraft.potted_pale_oak_sapling": "Ungt blegt egetræ potteplante",
  "block.minecraft.potted_pink_tulip": "Lyserød tulipan potteplante",
  "block.minecraft.potted_poppy": "Valmue potteplante",
  "block.minecraft.potted_red_mushroom": "Rød svamp potteplante",
  "block.minecraft.potted_red_tulip": "Rød tulipan potteplante",
  "block.minecraft.potted_spruce_sapling": "Ungt grantræ potteplante",
  "block.minecraft.potted_torchflower": "Fakkelblomst potteplante",
  "block.minecraft.potted_warped_fungus": "Forskruet svamp potteplante",
  "block.minecraft.potted_warped_roots": "Forskruede rødder potteplante",
  "block.minecraft.potted_white_tulip": "Hvid tulipan potteplante",
  "block.minecraft.potted_wither_rose": "Wither rose potteplante",
  "block.minecraft.powder_snow": "Pulversne",
  "block.minecraft.powder_snow_cauldron": "Pulversnegryde",
  "block.minecraft.powered_rail": "Strømspor",
  "block.minecraft.prismarine": "Prismarine",
  "block.minecraft.prismarine_brick_slab": "Prismarine-murstensflise",
  "block.minecraft.prismarine_brick_stairs": "Prismarine-murstenstrappe",
  "block.minecraft.prismarine_bricks": "Prismarine mursten",
  "block.minecraft.prismarine_slab": "Prismarine-flise",
  "block.minecraft.prismarine_stairs": "Prismarine-trappe",
  "block.minecraft.prismarine_wall": "Prismarine-væg",
  "block.minecraft.pumpkin": "Græskar",
  "block.minecraft.pumpkin_stem": "Græskar stilk",
  "block.minecraft.purple_banner": "Lilla banner",
  "block.minecraft.purple_bed": "Lilla seng",
  "block.minecraft.purple_candle": "Lilla stearinlys",
  "block.minecraft.purple_candle_cake": "Kage med lilla stearinlys",
  "block.minecraft.purple_carpet": "Lilla tæppe",
  "block.minecraft.purple_concrete": "Lilla beton",
  "block.minecraft.purple_concrete_powder": "Lilla betonpulver",
  "block.minecraft.purple_glazed_terracotta": "Lilla glaseret terrakotta",
  "block.minecraft.purple_shulker_box": "Lilla shulkerboks",
  "block.minecraft.purple_stained_glass": "Lilla farvet glas",
  "block.minecraft.purple_stained_glass_pane": "Lilla farvet glaspanel",
  "block.minecraft.purple_terracotta": "Lilla terrakotta",
  "block.minecraft.purple_wool": "Lilla uld",
  "block.minecraft.purpur_block": "Purpurblok",
  "block.minecraft.purpur_pillar": "Purpur søjle",
  "block.minecraft.purpur_slab": "Purpur-flise",
  "block.minecraft.purpur_stairs": "Purpur trappe",
  "block.minecraft.quartz_block": "Blok af kvarts",
  "block.minecraft.quartz_bricks": "Kvartsmursten",
  "block.minecraft.quartz_pillar": "Kvartssøjle",
  "block.minecraft.quartz_slab": "Kvartsflise",
  "block.minecraft.quartz_stairs": "Kvartstrappe",
  "block.minecraft.rail": "Spor",
  "block.minecraft.raw_copper_block": "Blok af rå kobber",
  "block.minecraft.raw_gold_block": "Blok af rå guld",
  "block.minecraft.raw_iron_block": "Blok af rå jern",
  "block.minecraft.red_banner": "Rødt banner",
  "block.minecraft.red_bed": "Rød seng",
  "block.minecraft.red_candle": "Rødt stearinlys",
  "block.minecraft.red_candle_cake": "Kage med rødt stearinlys",
  "block.minecraft.red_carpet": "Rødt tæppe",
  "block.minecraft.red_concrete": "Rød beton",
  "block.minecraft.red_concrete_powder": "Rødt betonpulver",
  "block.minecraft.red_glazed_terracotta": "Rød glaseret terrakotta",
  "block.minecraft.red_mushroom": "Rød svamp",
  "block.minecraft.red_mushroom_block": "Rød svampeblok",
  "block.minecraft.red_nether_brick_slab": "Rød nether-murstensflise",
  "block.minecraft.red_nether_brick_stairs": "Rød nether-murstenstrappe",
  "block.minecraft.red_nether_brick_wall": "Rød Nether-murstensvæg",
  "block.minecraft.red_nether_bricks": "Røde nethermursten",
  "block.minecraft.red_sand": "Rødt sand",
  "block.minecraft.red_sandstone": "Rød sandsten",
  "block.minecraft.red_sandstone_slab": "Rød sandstensflise",
  "block.minecraft.red_sandstone_stairs": "Rød sandstenstrappe",
  "block.minecraft.red_sandstone_wall": "Rød sandstensvæg",
  "block.minecraft.red_shulker_box": "Rød shulkerboks",
  "block.minecraft.red_stained_glass": "Rødt farvet glas",
  "block.minecraft.red_stained_glass_pane": "Rødt farvet glaspanel",
  "block.minecraft.red_terracotta": "Rød terrakotta",
  "block.minecraft.red_tulip": "Rød tulipan",
  "block.minecraft.red_wool": "Rød uld",
  "block.minecraft.redstone_block": "Blok af redstone",
  "block.minecraft.redstone_lamp": "Redstonelampe",
  "block.minecraft.redstone_ore": "Redstonemalm",
  "block.minecraft.redstone_torch": "Redstonefakkel",
  "block.minecraft.redstone_wall_torch": "Redstonevægfakkel",
  "block.minecraft.redstone_wire": "Redstoneledning",
  "block.minecraft.reinforced_deepslate": "Forstærket dybskifer",
  "block.minecraft.repeater": "Redstone-gentager",
  "block.minecraft.repeating_command_block": "Gentagende kommandoblok",
  "block.minecraft.resin_block": "Blok af harpiks",
  "block.minecraft.resin_brick_slab": "Harpiksmurstensflise",
  "block.minecraft.resin_brick_stairs": "Harpiks-murstenstrappe",
  "block.minecraft.resin_brick_wall": "Harpiks-murstensvæg",
  "block.minecraft.resin_bricks": "Harpiksmursten",
  "block.minecraft.resin_clump": "Harpiksklump",
  "block.minecraft.respawn_anchor": "Genoplivelsesanker",
  "block.minecraft.rooted_dirt": "Rodfyldt jord",
  "block.minecraft.rose_bush": "Rosenbusk",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandsten",
  "block.minecraft.sandstone_slab": "Sandstensflise",
  "block.minecraft.sandstone_stairs": "Sandstenstrappe",
  "block.minecraft.sandstone_wall": "Sandstensvæg",
  "block.minecraft.scaffolding": "Stillads",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkkatalysator",
  "block.minecraft.sculk_sensor": "Sculk-sensor",
  "block.minecraft.sculk_shrieker": "Sculkskriger",
  "block.minecraft.sculk_vein": "Sculkåre",
  "block.minecraft.sea_lantern": "Sølanterne",
  "block.minecraft.sea_pickle": "Søpølse",
  "block.minecraft.seagrass": "Søgræs",
  "block.minecraft.set_spawn": "Genopståpunkt sat",
  "block.minecraft.short_dry_grass": "Kort tørt græs",
  "block.minecraft.short_grass": "Kort græs",
  "block.minecraft.shroomlight": "Svampelys",
  "block.minecraft.shulker_box": "Shulkerboks",
  "block.minecraft.skeleton_skull": "Kranium",
  "block.minecraft.skeleton_wall_skull": "Vægkranie",
  "block.minecraft.slime_block": "Slimblok",
  "block.minecraft.small_amethyst_bud": "Lille ametystknop",
  "block.minecraft.small_dripleaf": "Lille dryppeblad",
  "block.minecraft.smithing_table": "Smedebord",
  "block.minecraft.smoker": "Rygeovn",
  "block.minecraft.smooth_basalt": "Glat basalt",
  "block.minecraft.smooth_quartz": "Glat kvartsblok",
  "block.minecraft.smooth_quartz_slab": "Glat kvartsflise",
  "block.minecraft.smooth_quartz_stairs": "Glat kvartstrappe",
  "block.minecraft.smooth_red_sandstone": "Glat rød sandsten",
  "block.minecraft.smooth_red_sandstone_slab": "Glat rød sandstensflise",
  "block.minecraft.smooth_red_sandstone_stairs": "Glat rød sandstenstrappe",
  "block.minecraft.smooth_sandstone": "Glat sandsten",
  "block.minecraft.smooth_sandstone_slab": "Glat sandstensflise",
  "block.minecraft.smooth_sandstone_stairs": "Glat sandstenstrappe",
  "block.minecraft.smooth_stone": "Glat sten",
  "block.minecraft.smooth_stone_slab": "Glat stenflise",
  "block.minecraft.sniffer_egg": "Snifferæg",
  "block.minecraft.snow": "Sne",
  "block.minecraft.snow_block": "Sneblok",
  "block.minecraft.soul_campfire": "Sjælelejrbål",
  "block.minecraft.soul_fire": "Sjæleild",
  "block.minecraft.soul_lantern": "Sjælelanterne",
  "block.minecraft.soul_sand": "Sjælesand",
  "block.minecraft.soul_soil": "Sjælejord",
  "block.minecraft.soul_torch": "Sjæleild fakkel",
  "block.minecraft.soul_wall_torch": "Sjælevægsfakkel",
  "block.minecraft.spawn.not_valid": "Du har ingen hjemmeseng eller ladet genoplivelsesanker, eller så er det blevet blokeret",
  "block.minecraft.spawner": "Monsterspawner",
  "block.minecraft.spawner.desc1": "Interager med fremkaldningsæg:",
  "block.minecraft.spawner.desc2": "Indstiller væsen-type",
  "block.minecraft.sponge": "Svamp",
  "block.minecraft.spore_blossom": "Sporeblomst",
  "block.minecraft.spruce_button": "Granknap",
  "block.minecraft.spruce_door": "Grandør",
  "block.minecraft.spruce_fence": "Granhegn",
  "block.minecraft.spruce_fence_gate": "Granhegnslåge",
  "block.minecraft.spruce_hanging_sign": "Hængende granskilt",
  "block.minecraft.spruce_leaves": "Grannåle",
  "block.minecraft.spruce_log": "Granstamme",
  "block.minecraft.spruce_planks": "Granplanker",
  "block.minecraft.spruce_pressure_plate": "Grantrykplade",
  "block.minecraft.spruce_sapling": "Ungt grantræ",
  "block.minecraft.spruce_shelf": "Granhylde",
  "block.minecraft.spruce_sign": "Grantræsskilt",
  "block.minecraft.spruce_slab": "Granplade",
  "block.minecraft.spruce_stairs": "Grantrappe",
  "block.minecraft.spruce_trapdoor": "Granlem",
  "block.minecraft.spruce_wall_hanging_sign": "Væghængende granskilt",
  "block.minecraft.spruce_wall_sign": "Grantræsvægskilt",
  "block.minecraft.spruce_wood": "Grantræ",
  "block.minecraft.sticky_piston": "Klistret stempel",
  "block.minecraft.stone": "Sten",
  "block.minecraft.stone_brick_slab": "Stenmurstensflise",
  "block.minecraft.stone_brick_stairs": "Stenmurstenstrappe",
  "block.minecraft.stone_brick_wall": "Stenmurstensvæg",
  "block.minecraft.stone_bricks": "Stenmursten",
  "block.minecraft.stone_button": "Stenknap",
  "block.minecraft.stone_pressure_plate": "Sten trykplade",
  "block.minecraft.stone_slab": "Stenflise",
  "block.minecraft.stone_stairs": "Stentrappe",
  "block.minecraft.stonecutter": "Stenskærer",
  "block.minecraft.stripped_acacia_log": "Afbarket akaciestamme",
  "block.minecraft.stripped_acacia_wood": "Afbarket akacietræ",
  "block.minecraft.stripped_bamboo_block": "Afbarket blok af bambus",
  "block.minecraft.stripped_birch_log": "Afbarket birkestamme",
  "block.minecraft.stripped_birch_wood": "Afbarket birketræ",
  "block.minecraft.stripped_cherry_log": "Afbarket kirsebærstamme",
  "block.minecraft.stripped_cherry_wood": "Afbarket kirsebærtræ",
  "block.minecraft.stripped_crimson_hyphae": "Afbarket karmoisinhyfer",
  "block.minecraft.stripped_crimson_stem": "Afbarket karmoisinstilk",
  "block.minecraft.stripped_dark_oak_log": "Afbarket mørk egestamme",
  "block.minecraft.stripped_dark_oak_wood": "Afbarket mørk egetræ",
  "block.minecraft.stripped_jungle_log": "Afbarket junglestamme",
  "block.minecraft.stripped_jungle_wood": "Afbarket jungletræ",
  "block.minecraft.stripped_mangrove_log": "Afbarket mangrovestamme",
  "block.minecraft.stripped_mangrove_wood": "Afbarket mangrovetræ",
  "block.minecraft.stripped_oak_log": "Afbarket egestamme",
  "block.minecraft.stripped_oak_wood": "Afbarket egetræ",
  "block.minecraft.stripped_pale_oak_log": "Afbarket bleg egestamme",
  "block.minecraft.stripped_pale_oak_wood": "Afbarket blegt egetræ",
  "block.minecraft.stripped_spruce_log": "Afbarket granstamme",
  "block.minecraft.stripped_spruce_wood": "Afbarket grantræ",
  "block.minecraft.stripped_warped_hyphae": "Afbarkede forskruede hyfer",
  "block.minecraft.stripped_warped_stem": "Afbarket forskruet stilk",
  "block.minecraft.structure_block": "Strukturblok",
  "block.minecraft.structure_void": "Struktur-tomrum",
  "block.minecraft.sugar_cane": "Sukkerrør",
  "block.minecraft.sunflower": "Solsikke",
  "block.minecraft.suspicious_gravel": "Mistænkeligt grus",
  "block.minecraft.suspicious_sand": "Mistænkeligt sand",
  "block.minecraft.sweet_berry_bush": "Sød bærbusk",
  "block.minecraft.tall_dry_grass": "Højt tørt græs",
  "block.minecraft.tall_grass": "Højt græs",
  "block.minecraft.tall_seagrass": "Højt søgræs",
  "block.minecraft.target": "Mål",
  "block.minecraft.terracotta": "Terrakotta",
  "block.minecraft.test_block": "Testblok",
  "block.minecraft.test_instance_block": "Testinstansblok",
  "block.minecraft.tinted_glass": "Tonet glas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT-eksplosioner er deaktiveret",
  "block.minecraft.torch": "Fakkel",
  "block.minecraft.torchflower": "Fakkelblomst",
  "block.minecraft.torchflower_crop": "Fakkelblomst afgrøde",
  "block.minecraft.trapped_chest": "Fældekiste",
  "block.minecraft.trial_spawner": "Prøvelsesspawner",
  "block.minecraft.tripwire": "Snubletråd",
  "block.minecraft.tripwire_hook": "Snubletrådskrog",
  "block.minecraft.tube_coral": "Orgelkoral",
  "block.minecraft.tube_coral_block": "Orgelkoralblok",
  "block.minecraft.tube_coral_fan": "Orgelkoralvifte",
  "block.minecraft.tube_coral_wall_fan": "Orgelkoralvægvifte",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Tuf-murstensflise",
  "block.minecraft.tuff_brick_stairs": "Tuf-murstenstrappe",
  "block.minecraft.tuff_brick_wall": "Tuf-murstensvæg",
  "block.minecraft.tuff_bricks": "Tufmursten",
  "block.minecraft.tuff_slab": "Tufplade",
  "block.minecraft.tuff_stairs": "Tuftrappe",
  "block.minecraft.tuff_wall": "Tufvæg",
  "block.minecraft.turtle_egg": "Skildpaddeæg",
  "block.minecraft.twisting_vines": "Snoende lianer",
  "block.minecraft.twisting_vines_plant": "Snoende-lian plante",
  "block.minecraft.vault": "Boks",
  "block.minecraft.verdant_froglight": "Grønt frølys",
  "block.minecraft.vine": "Lianer",
  "block.minecraft.void_air": "Tomrumsluft",
  "block.minecraft.wall_torch": "Vægfakkel",
  "block.minecraft.warped_button": "Forskruet knap",
  "block.minecraft.warped_door": "Forskruet dør",
  "block.minecraft.warped_fence": "Forskruet hegn",
  "block.minecraft.warped_fence_gate": "Forskruet hegnslåge",
  "block.minecraft.warped_fungus": "Forskruet svamp",
  "block.minecraft.warped_hanging_sign": "Hængende forskruet skilt",
  "block.minecraft.warped_hyphae": "Forskruet hyfer",
  "block.minecraft.warped_nylium": "Forskruet nylium",
  "block.minecraft.warped_planks": "Forskruede planker",
  "block.minecraft.warped_pressure_plate": "Forskruet trykplade",
  "block.minecraft.warped_roots": "Forskruet rødder",
  "block.minecraft.warped_shelf": "Forskruet hylde",
  "block.minecraft.warped_sign": "Forskruet skilt",
  "block.minecraft.warped_slab": "Forskruet plade",
  "block.minecraft.warped_stairs": "Forskruet trappe",
  "block.minecraft.warped_stem": "Forskruet stilk",
  "block.minecraft.warped_trapdoor": "Forskruet lem",
  "block.minecraft.warped_wall_hanging_sign": "Væghængende forskruet skilt",
  "block.minecraft.warped_wall_sign": "Forskruet vægskilt",
  "block.minecraft.warped_wart_block": "Forskruet nether-vorteblok",
  "block.minecraft.water": "Vand",
  "block.minecraft.water_cauldron": "Vandgryde",
  "block.minecraft.waxed_chiseled_copper": "Vokset mejslet kobber",
  "block.minecraft.waxed_copper_bars": "Vokset kobbertremmer",
  "block.minecraft.waxed_copper_block": "Vokset blok af kobber",
  "block.minecraft.waxed_copper_bulb": "Vokset kobberpære",
  "block.minecraft.waxed_copper_chain": "Vokset kobberkæde",
  "block.minecraft.waxed_copper_chest": "Vokset kobberkiste",
  "block.minecraft.waxed_copper_door": "Vokset kobberdør",
  "block.minecraft.waxed_copper_golem_statue": "Vokset kobbergolemstatue",
  "block.minecraft.waxed_copper_grate": "Vokset kobberrist",
  "block.minecraft.waxed_copper_lantern": "Vokset kobberlanterne",
  "block.minecraft.waxed_copper_trapdoor": "Vokset kobberlem",
  "block.minecraft.waxed_cut_copper": "Vokset skåret kobber",
  "block.minecraft.waxed_cut_copper_slab": "Vokset skåret kobberplade",
  "block.minecraft.waxed_cut_copper_stairs": "Vokset skåret kobbertrappe",
  "block.minecraft.waxed_exposed_chiseled_copper": "Vokset blotlagt mejslet kobber",
  "block.minecraft.waxed_exposed_copper": "Vokset blotlagt kobber",
  "block.minecraft.waxed_exposed_copper_bars": "Vokset blotlagt kobbertremmer",
  "block.minecraft.waxed_exposed_copper_bulb": "Vokset blotlagt kobberpære",
  "block.minecraft.waxed_exposed_copper_chain": "Vokset blotlagt kobberkæde",
  "block.minecraft.waxed_exposed_copper_chest": "Vokset blotlagt kobberkiste",
  "block.minecraft.waxed_exposed_copper_door": "Vokset blotlagt kobberdør",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Vokset blotlagt kobbergolemstatue",
  "block.minecraft.waxed_exposed_copper_grate": "Vokset blotlagt kobberrist",
  "block.minecraft.waxed_exposed_copper_lantern": "Vokset blotlagt kobberlanterne",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Vokset blotlagt kobberlem",
  "block.minecraft.waxed_exposed_cut_copper": "Vokset blotlagt skåret kobber",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Vokset blotlagt skåret kobberplade",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Vokset blotlagt skåret kobbertrappe",
  "block.minecraft.waxed_exposed_lightning_rod": "Vokset blotlagt lynafleder",
  "block.minecraft.waxed_lightning_rod": "Vokset lynafleder",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Vokset oxideret mejslet kobber",
  "block.minecraft.waxed_oxidized_copper": "Vokset oxideret kobber",
  "block.minecraft.waxed_oxidized_copper_bars": "Vokset oxideret kobbertremmer",
  "block.minecraft.waxed_oxidized_copper_bulb": "Vokset oxideret kobberpære",
  "block.minecraft.waxed_oxidized_copper_chain": "Vokset oxideret kobberkæde",
  "block.minecraft.waxed_oxidized_copper_chest": "Vokset oxideret kobberkiste",
  "block.minecraft.waxed_oxidized_copper_door": "Vokset oxideret kobberdør",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Vokset oxideret kobbergolemstatue",
  "block.minecraft.waxed_oxidized_copper_grate": "Vokset oxideret kobberrist",
  "block.minecraft.waxed_oxidized_copper_lantern": "Vokset oxideret kobberlanterne",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Vokset oxideret kobberlem",
  "block.minecraft.waxed_oxidized_cut_copper": "Vokset oxideret skåret kobber",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Vokset oxideret skåret Kobberplade",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Vokset oxideret skåret kobbertrappe",
  "block.minecraft.waxed_oxidized_lightning_rod": "Vokset oxideret lynafleder",
  "block.minecraft.waxed_weathered_chiseled_copper": "Vokset forvitret kobber",
  "block.minecraft.waxed_weathered_copper": "Vokset forvitret kobber",
  "block.minecraft.waxed_weathered_copper_bars": "Vokset forvitret kobbertremmer",
  "block.minecraft.waxed_weathered_copper_bulb": "Vokset forvitret kobberpære",
  "block.minecraft.waxed_weathered_copper_chain": "Vokset forvitret kobberkæde",
  "block.minecraft.waxed_weathered_copper_chest": "Vokset forvitret kobberkiste",
  "block.minecraft.waxed_weathered_copper_door": "Vokset forvitret kobberdør",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Vokset forvitret kobbergolemstatue",
  "block.minecraft.waxed_weathered_copper_grate": "Vokset forvitret kobberrist",
  "block.minecraft.waxed_weathered_copper_lantern": "Vokset forvitret kobberlanterne",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Vokset forvitret kobberlem",
  "block.minecraft.waxed_weathered_cut_copper": "Vokset forvitret skåret kobber",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Vokset forvitret skåret kobberplade",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Vokset forvitret skåret kobbertrappe",
  "block.minecraft.waxed_weathered_lightning_rod": "Vokset forvitret lynafleder",
  "block.minecraft.weathered_chiseled_copper": "Forvitret mejslet kobber",
  "block.minecraft.weathered_copper": "Forvitret kobber",
  "block.minecraft.weathered_copper_bars": "Forvitret kobbertremmer",
  "block.minecraft.weathered_copper_bulb": "Forvitret kobberpære",
  "block.minecraft.weathered_copper_chain": "Forvitret kobberkæde",
  "block.minecraft.weathered_copper_chest": "Forvitret kobberkiste",
  "block.minecraft.weathered_copper_door": "Forvitret kobberdør",
  "block.minecraft.weathered_copper_golem_statue": "Forvitret kobbergolemstatue",
  "block.minecraft.weathered_copper_grate": "Forvitret kobberrist",
  "block.minecraft.weathered_copper_lantern": "Forvitret kobberlanterne",
  "block.minecraft.weathered_copper_trapdoor": "Forvitret kobberlem",
  "block.minecraft.weathered_cut_copper": "Forvitret skåret kobber",
  "block.minecraft.weathered_cut_copper_slab": "Forvitret skåret kobberplade",
  "block.minecraft.weathered_cut_copper_stairs": "Forvitret skåret kobbertrappe",
  "block.minecraft.weathered_lightning_rod": "Forvitret lynafleder",
  "block.minecraft.weeping_vines": "Tudende lianer",
  "block.minecraft.weeping_vines_plant": "Grædende lianplante",
  "block.minecraft.wet_sponge": "Våd svamp",
  "block.minecraft.wheat": "Hvede afgrøder",
  "block.minecraft.white_banner": "Hvidt banner",
  "block.minecraft.white_bed": "Hvid seng",
  "block.minecraft.white_candle": "Hvidt stearinlys",
  "block.minecraft.white_candle_cake": "Kage med hvidt stearinlys",
  "block.minecraft.white_carpet": "Hvidt tæppe",
  "block.minecraft.white_concrete": "Hvid beton",
  "block.minecraft.white_concrete_powder": "Hvidt betonpulver",
  "block.minecraft.white_glazed_terracotta": "Hvid glaseret terrakotta",
  "block.minecraft.white_shulker_box": "Hvid shulkerboks",
  "block.minecraft.white_stained_glass": "Hvidt farvet glas",
  "block.minecraft.white_stained_glass_pane": "Hvidt farvet glaspanel",
  "block.minecraft.white_terracotta": "Hvid terrakotta",
  "block.minecraft.white_tulip": "Hvid tulipan",
  "block.minecraft.white_wool": "Hvid uld",
  "block.minecraft.wildflowers": "Vildblomster",
  "block.minecraft.wither_rose": "Wither rose",
  "block.minecraft.wither_skeleton_skull": "Witherskeletkranium",
  "block.minecraft.wither_skeleton_wall_skull": "Wither vægkranie",
  "block.minecraft.yellow_banner": "Gult banner",
  "block.minecraft.yellow_bed": "Gul seng",
  "block.minecraft.yellow_candle": "Gult stearinlys",
  "block.minecraft.yellow_candle_cake": "Kage med gult stearinlys",
  "block.minecraft.yellow_carpet": "Gult tæppe",
  "block.minecraft.yellow_concrete": "Gul beton",
  "block.minecraft.yellow_concrete_powder": "Gult betonpulver",
  "block.minecraft.yellow_glazed_terracotta": "Gul glaseret terrakotta",
  "block.minecraft.yellow_shulker_box": "Gul shulkerboks",
  "block.minecraft.yellow_stained_glass": "Gult farvet glas",
  "block.minecraft.yellow_stained_glass_pane": "Gult farvet glaspanel",
  "block.minecraft.yellow_terracotta": "Gul terrakotta",
  "block.minecraft.yellow_wool": "Gul uld",
  "block.minecraft.zombie_head": "Zombiehoved",
  "block.minecraft.zombie_wall_head": "Zombie-væghoved",
  "item.minecraft.acacia_boat": "Akaciebåd",
  "item.minecraft.acacia_chest_boat": "Akaciebåd med kiste",
  "item.minecraft.allay_spawn_egg": "Hjælpeånd fremkaldningsæg",
  "item.minecraft.amethyst_shard": "Ametyst skår",
  "item.minecraft.angler_pottery_shard": "Lystfisker keramikskår",
  "item.minecraft.angler_pottery_sherd": "Lystfisker keramikfragment",
  "item.minecraft.apple": "Æble",
  "item.minecraft.archer_pottery_shard": "Bueskytte keramikskår",
  "item.minecraft.archer_pottery_sherd": "Bueskytte keramikfragment",
  "item.minecraft.armadillo_scute": "Bæltedyrs skæl",
  "item.minecraft.armadillo_spawn_egg": "Bæltedyr fremkaldningsæg",
  "item.minecraft.armor_stand": "Brynjeholder",
  "item.minecraft.arms_up_pottery_shard": "Armene op keramikskår",
  "item.minecraft.arms_up_pottery_sherd": "Armene oppe keramikfragment",
  "item.minecraft.arrow": "Pil",
  "item.minecraft.axolotl_bucket": "Spand med axolotl",
  "item.minecraft.axolotl_spawn_egg": "Axolotl fremkaldningsæg",
  "item.minecraft.baked_potato": "Bagt kartoffel",
  "item.minecraft.bamboo_chest_raft": "Bambustømmerflåde med kiste",
  "item.minecraft.bamboo_raft": "Bambustømmerflåde",
  "item.minecraft.bat_spawn_egg": "Flagermus fremkaldningsæg",
  "item.minecraft.bee_spawn_egg": "Bi fremkaldingsæg",
  "item.minecraft.beef": "Rå bøf",
  "item.minecraft.beetroot": "Rødbede",
  "item.minecraft.beetroot_seeds": "Rødbedefrø",
  "item.minecraft.beetroot_soup": "Rødbedesuppe",
  "item.minecraft.birch_boat": "Birkebåd",
  "item.minecraft.birch_chest_boat": "Birkebåd med kiste",
  "item.minecraft.black_bundle": "Sort bundt",
  "item.minecraft.black_dye": "Sort farvestof",
  "item.minecraft.black_harness": "Sort seletøj",
  "item.minecraft.blade_pottery_shard": "Klinge keramikskår",
  "item.minecraft.blade_pottery_sherd": "Klinge keramikfragment",
  "item.minecraft.blaze_powder": "Blaze-pulver",
  "item.minecraft.blaze_rod": "Blaze-stav",
  "item.minecraft.blaze_spawn_egg": "Blaze fremkaldningsæg",
  "item.minecraft.blue_bundle": "Blåt bundt",
  "item.minecraft.blue_dye": "Blåt farvestof",
  "item.minecraft.blue_egg": "Blåt æg",
  "item.minecraft.blue_harness": "Blåt seletøj",
  "item.minecraft.bogged_spawn_egg": "Sumpskelet fremkaldningsæg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt rustningspynt",
  "item.minecraft.bone": "Knogle",
  "item.minecraft.bone_meal": "Benmel",
  "item.minecraft.book": "Bog",
  "item.minecraft.bordure_indented_banner_pattern": "Takket bannermønster",
  "item.minecraft.bow": "Bue",
  "item.minecraft.bowl": "Skål",
  "item.minecraft.bread": "Brød",
  "item.minecraft.breeze_rod": "Vindvæsen-stav",
  "item.minecraft.breeze_spawn_egg": "Vindvæsen fremkaldningsæg",
  "item.minecraft.brewer_pottery_shard": "Brygger keramikskår",
  "item.minecraft.brewer_pottery_sherd": "Brygger keramikfragment",
  "item.minecraft.brewing_stand": "Bryggestand",
  "item.minecraft.brick": "Mursten",
  "item.minecraft.brown_bundle": "Brunt bundt",
  "item.minecraft.brown_dye": "Brunt farvestof",
  "item.minecraft.brown_egg": "Brunt æg",
  "item.minecraft.brown_harness": "Brunt seletøj",
  "item.minecraft.brush": "Børste",
  "item.minecraft.bucket": "Spand",
  "item.minecraft.bundle": "Bundt",
  "item.minecraft.bundle.empty": "Tom",
  "item.minecraft.bundle.empty.description": "Kan holde en blandet stak af genstande",
  "item.minecraft.bundle.full": "Fuld",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Brænd keramikskår",
  "item.minecraft.burn_pottery_sherd": "Brænd keramikfragment",
  "item.minecraft.camel_husk_spawn_egg": "Udtørret kamel fremkaldningsæg",
  "item.minecraft.camel_spawn_egg": "Kamel fremkaldningsæg",
  "item.minecraft.carrot": "Gulerod",
  "item.minecraft.carrot_on_a_stick": "Gulerod på en pind",
  "item.minecraft.cat_spawn_egg": "Kat fremkaldningsæg",
  "item.minecraft.cauldron": "Gryde",
  "item.minecraft.cave_spider_spawn_egg": "Huleedderkop fremkaldningsæg",
  "item.minecraft.chainmail_boots": "Brynjestøvler",
  "item.minecraft.chainmail_chestplate": "Brynjebrystplade",
  "item.minecraft.chainmail_helmet": "Brynjehjelm",
  "item.minecraft.chainmail_leggings": "Brynjebukser",
  "item.minecraft.charcoal": "Trækul",
  "item.minecraft.cherry_boat": "Kirsebærbåd",
  "item.minecraft.cherry_chest_boat": "Kirsebærbåd med kiste",
  "item.minecraft.chest_minecart": "Minevogn med kiste",
  "item.minecraft.chicken": "Rå kylling",
  "item.minecraft.chicken_spawn_egg": "Kylling fremkaldningsæg",
  "item.minecraft.chorus_fruit": "Omkvædsfrugt",
  "item.minecraft.clay_ball": "Lerbold",
  "item.minecraft.clock": "Ur",
  "item.minecraft.coal": "Kul",
  "item.minecraft.coast_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Kyst rustningspynt",
  "item.minecraft.cocoa_beans": "Kakaobønner",
  "item.minecraft.cod": "Rå torsk",
  "item.minecraft.cod_bucket": "Spand med torsk",
  "item.minecraft.cod_spawn_egg": "Torsk fremkaldningsæg",
  "item.minecraft.command_block_minecart": "Minevogn med kommandoblok",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Bøf",
  "item.minecraft.cooked_chicken": "Stegt kylling",
  "item.minecraft.cooked_cod": "Bagt torsk",
  "item.minecraft.cooked_mutton": "Stegt fårekød",
  "item.minecraft.cooked_porkchop": "Stegt svinekotelet",
  "item.minecraft.cooked_rabbit": "Stegt kanin",
  "item.minecraft.cooked_salmon": "Bagt laks",
  "item.minecraft.cookie": "Småkage",
  "item.minecraft.copper_axe": "Kobberøkse",
  "item.minecraft.copper_boots": "Kobberstøvler",
  "item.minecraft.copper_chestplate": "Kobberbrystplade",
  "item.minecraft.copper_golem_spawn_egg": "Kobbergolem fremkaldningsæg",
  "item.minecraft.copper_helmet": "Kobberhjelm",
  "item.minecraft.copper_hoe": "Kobberlugejern",
  "item.minecraft.copper_horse_armor": "Kobberhestearmering",
  "item.minecraft.copper_ingot": "Kobberbarre",
  "item.minecraft.copper_leggings": "Kobberbukser",
  "item.minecraft.copper_nautilus_armor": "Kobbernautilarmering",
  "item.minecraft.copper_nugget": "Kobberklump",
  "item.minecraft.copper_pickaxe": "Kobberhakke",
  "item.minecraft.copper_shovel": "Kobberspade",
  "item.minecraft.copper_spear": "Kobberspyd",
  "item.minecraft.copper_sword": "Kobbersværd",
  "item.minecraft.cow_spawn_egg": "Ko fremkaldningsæg",
  "item.minecraft.creaking_spawn_egg": "Knirker fremkaldningsæg",
  "item.minecraft.creeper_banner_pattern": "Bannermønster",
  "item.minecraft.creeper_banner_pattern.desc": "Creepersymbol",
  "item.minecraft.creeper_banner_pattern.new": "Creepersymbol bannermønster",
  "item.minecraft.creeper_spawn_egg": "Creeper fremkaldningsæg",
  "item.minecraft.crossbow": "Armbrøst",
  "item.minecraft.crossbow.projectile": "Projektil:",
  "item.minecraft.crossbow.projectile.multiple": "Projektil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projektil: %s",
  "item.minecraft.cyan_bundle": "Turkis bundt",
  "item.minecraft.cyan_dye": "Turkis farvestof",
  "item.minecraft.cyan_harness": "Turkis seletøj",
  "item.minecraft.danger_pottery_shard": "Fare keramikskår",
  "item.minecraft.danger_pottery_sherd": "Fare keramikfragment",
  "item.minecraft.dark_oak_boat": "Mørk egetræsbåd",
  "item.minecraft.dark_oak_chest_boat": "Mørk egetræsbåd med kiste",
  "item.minecraft.debug_stick": "Fejlfindingspind",
  "item.minecraft.debug_stick.empty": "%s har ingen egenskaber",
  "item.minecraft.debug_stick.select": "valgt \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" til %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamantøkse",
  "item.minecraft.diamond_boots": "Diamantstøvler",
  "item.minecraft.diamond_chestplate": "Diamantbrystplade",
  "item.minecraft.diamond_helmet": "Diamanthjelm",
  "item.minecraft.diamond_hoe": "Diamantlugejern",
  "item.minecraft.diamond_horse_armor": "Diamanthestearmering",
  "item.minecraft.diamond_leggings": "Diamantbukser",
  "item.minecraft.diamond_nautilus_armor": "Diamantnautilarmering",
  "item.minecraft.diamond_pickaxe": "Diamanthakke",
  "item.minecraft.diamond_shovel": "Diamantspade",
  "item.minecraft.diamond_spear": "Diamantspyd",
  "item.minecraft.diamond_sword": "Diamantsværd",
  "item.minecraft.disc_fragment_5": "Pladefragment",
  "item.minecraft.disc_fragment_5.desc": "Musikplade - 5",
  "item.minecraft.dolphin_spawn_egg": "Delfin fremkaldningsæg",
  "item.minecraft.donkey_spawn_egg": "Æsel fremkaldningsæg",
  "item.minecraft.dragon_breath": "Dragens ånde",
  "item.minecraft.dried_kelp": "Tørret tang",
  "item.minecraft.drowned_spawn_egg": "Draug fremkaldningsæg",
  "item.minecraft.dune_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ødemark rustningspynt",
  "item.minecraft.echo_shard": "Ekkoskår",
  "item.minecraft.egg": "Æg",
  "item.minecraft.elder_guardian_spawn_egg": "Gammel beskytter fremkaldningsæg",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Fortryllet bog",
  "item.minecraft.enchanted_golden_apple": "Fortryllet gyldent æble",
  "item.minecraft.end_crystal": "End-krystal",
  "item.minecraft.ender_dragon_spawn_egg": "Ender-drage fremkaldningsæg",
  "item.minecraft.ender_eye": "Ender-øje",
  "item.minecraft.ender_pearl": "Ender-perle",
  "item.minecraft.enderman_spawn_egg": "Enderman fremkaldningsæg",
  "item.minecraft.endermite_spawn_egg": "Endermite fremkaldningsæg",
  "item.minecraft.evoker_spawn_egg": "Fremkalder fremkaldningsæg",
  "item.minecraft.experience_bottle": "Fortryllelsesflaske",
  "item.minecraft.explorer_pottery_shard": "Opdagelsesrejsende keramikskår",
  "item.minecraft.explorer_pottery_sherd": "Opdagelsesrejsende keramikfragment",
  "item.minecraft.eye_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Øje rustningspynt",
  "item.minecraft.feather": "Fjer",
  "item.minecraft.fermented_spider_eye": "Fermenteret edderkoppeøje",
  "item.minecraft.field_masoned_banner_pattern": "Murstensmønster bannermønster",
  "item.minecraft.filled_map": "Kort",
  "item.minecraft.fire_charge": "Ildladning",
  "item.minecraft.firework_rocket": "Fyrværkeriraket",
  "item.minecraft.firework_rocket.flight": "Flyvevarighed:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Fyrværkeristjerne",
  "item.minecraft.firework_star.black": "Sort",
  "item.minecraft.firework_star.blue": "Blå",
  "item.minecraft.firework_star.brown": "Brun",
  "item.minecraft.firework_star.custom_color": "Tilpasset",
  "item.minecraft.firework_star.cyan": "Turkis",
  "item.minecraft.firework_star.fade_to": "Udton til",
  "item.minecraft.firework_star.flicker": "Glimt",
  "item.minecraft.firework_star.gray": "Grå",
  "item.minecraft.firework_star.green": "Grøn",
  "item.minecraft.firework_star.light_blue": "Lyseblå",
  "item.minecraft.firework_star.light_gray": "Lysegrå",
  "item.minecraft.firework_star.lime": "Limegrøn",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Orange",
  "item.minecraft.firework_star.pink": "Lyserød",
  "item.minecraft.firework_star.purple": "Lilla",
  "item.minecraft.firework_star.red": "Rød",
  "item.minecraft.firework_star.shape": "Ukendt form",
  "item.minecraft.firework_star.shape.burst": "Eksplosion",
  "item.minecraft.firework_star.shape.creeper": "Creeper-formet",
  "item.minecraft.firework_star.shape.large_ball": "Stor kugle",
  "item.minecraft.firework_star.shape.small_ball": "Lille kugle",
  "item.minecraft.firework_star.shape.star": "Stjerneformet",
  "item.minecraft.firework_star.trail": "Spor",
  "item.minecraft.firework_star.white": "Hvid",
  "item.minecraft.firework_star.yellow": "Gul",
  "item.minecraft.fishing_rod": "Fiskestang",
  "item.minecraft.flint": "Flint",
  "item.minecraft.flint_and_steel": "Flint og stål",
  "item.minecraft.flow_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Hvirvel rustningspynt",
  "item.minecraft.flow_banner_pattern": "Bannermønster",
  "item.minecraft.flow_banner_pattern.desc": "Hvirvel",
  "item.minecraft.flow_banner_pattern.new": "Hvirvel bannermønster",
  "item.minecraft.flow_pottery_sherd": "Hvirvel-potteskår",
  "item.minecraft.flower_banner_pattern": "Bannermønster",
  "item.minecraft.flower_banner_pattern.desc": "Blomstersymbol",
  "item.minecraft.flower_banner_pattern.new": "Blomstersymbol bannermønster",
  "item.minecraft.flower_pot": "Blomsterkrukke",
  "item.minecraft.fox_spawn_egg": "Ræv fremkaldningsæg",
  "item.minecraft.friend_pottery_shard": "Ven keramikskår",
  "item.minecraft.friend_pottery_sherd": "Ven keramikfragment",
  "item.minecraft.frog_spawn_egg": "Frø fremkaldningsæg",
  "item.minecraft.furnace_minecart": "Minevogn med ovn",
  "item.minecraft.ghast_spawn_egg": "Ghast fremkaldningsæg",
  "item.minecraft.ghast_tear": "Ghast-tåre",
  "item.minecraft.glass_bottle": "Glasflaske",
  "item.minecraft.glistering_melon_slice": "Glitrende melonskive",
  "item.minecraft.globe_banner_pattern": "Bannermønster",
  "item.minecraft.globe_banner_pattern.desc": "Globus",
  "item.minecraft.globe_banner_pattern.new": "Globus bannermønster",
  "item.minecraft.glow_berries": "Glødebær",
  "item.minecraft.glow_ink_sac": "Glødende blækpose",
  "item.minecraft.glow_item_frame": "Glødende genstandsramme",
  "item.minecraft.glow_squid_spawn_egg": "Glødesprutte-fremkaldningsæg",
  "item.minecraft.glowstone_dust": "Glødestenspulver",
  "item.minecraft.goat_horn": "Gedehorn",
  "item.minecraft.goat_spawn_egg": "Ged fremkaldningsæg",
  "item.minecraft.gold_ingot": "Guldbarre",
  "item.minecraft.gold_nugget": "Guldklump",
  "item.minecraft.golden_apple": "Gyldent æble",
  "item.minecraft.golden_axe": "Guldøkse",
  "item.minecraft.golden_boots": "Guldstøvler",
  "item.minecraft.golden_carrot": "Gylden gulerod",
  "item.minecraft.golden_chestplate": "Guldbrystplade",
  "item.minecraft.golden_helmet": "Guldhjelm",
  "item.minecraft.golden_hoe": "Guldlugejern",
  "item.minecraft.golden_horse_armor": "Guldhestearmering",
  "item.minecraft.golden_leggings": "Guldbukser",
  "item.minecraft.golden_nautilus_armor": "Guldnautilarmering",
  "item.minecraft.golden_pickaxe": "Guldhakke",
  "item.minecraft.golden_shovel": "Guldspade",
  "item.minecraft.golden_spear": "Guldspyd",
  "item.minecraft.golden_sword": "Guldsværd",
  "item.minecraft.gray_bundle": "Gråt bundt",
  "item.minecraft.gray_dye": "Gråt farvestof",
  "item.minecraft.gray_harness": "Gråt seletøj",
  "item.minecraft.green_bundle": "Grønt bundt",
  "item.minecraft.green_dye": "Grønt farvestof",
  "item.minecraft.green_harness": "Grønt seletøj",
  "item.minecraft.guardian_spawn_egg": "Beskytter fremkaldningsæg",
  "item.minecraft.gunpowder": "Krudt",
  "item.minecraft.guster_banner_pattern": "Bannermønster",
  "item.minecraft.guster_banner_pattern.desc": "Vindvæsen",
  "item.minecraft.guster_banner_pattern.new": "Vindvæsen bannermønster",
  "item.minecraft.guster_pottery_sherd": "Vindvæsen keramikfragment",
  "item.minecraft.happy_ghast_spawn_egg": "Glad ghast fremkaldningsæg",
  "item.minecraft.harness": "Seletøj",
  "item.minecraft.heart_of_the_sea": "Havets hjerte",
  "item.minecraft.heart_pottery_shard": "Hjerte keramikskår",
  "item.minecraft.heart_pottery_sherd": "Hjerte keramikfragment",
  "item.minecraft.heartbreak_pottery_shard": "Hjertesorg keramikskår",
  "item.minecraft.heartbreak_pottery_sherd": "Hjertesorg keramikfragment",
  "item.minecraft.hoglin_spawn_egg": "Hoglin fremkaldningsæg",
  "item.minecraft.honey_bottle": "Honningflaske",
  "item.minecraft.honeycomb": "Bikage",
  "item.minecraft.hopper_minecart": "Minevogn med tragt",
  "item.minecraft.horse_spawn_egg": "Hest fremkaldningsæg",
  "item.minecraft.host_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.host_armor_trim_smithing_template.new": "Vært rustningspynt",
  "item.minecraft.howl_pottery_shard": "Hyl keramikskår",
  "item.minecraft.howl_pottery_sherd": "Hyl keramikfragment",
  "item.minecraft.husk_spawn_egg": "Udtørretskal fremkaldningsæg",
  "item.minecraft.ink_sac": "Blækpose",
  "item.minecraft.iron_axe": "Jernøkse",
  "item.minecraft.iron_boots": "Jernstøvler",
  "item.minecraft.iron_chestplate": "Jernbrystplade",
  "item.minecraft.iron_golem_spawn_egg": "Jerngolem fremkaldningsæg",
  "item.minecraft.iron_helmet": "Jernhjelm",
  "item.minecraft.iron_hoe": "Jernlugejern",
  "item.minecraft.iron_horse_armor": "Jernhestearmering",
  "item.minecraft.iron_ingot": "Jernbarre",
  "item.minecraft.iron_leggings": "Jernbukser",
  "item.minecraft.iron_nautilus_armor": "Jernnautilarmering",
  "item.minecraft.iron_nugget": "Jernklump",
  "item.minecraft.iron_pickaxe": "Jernhakke",
  "item.minecraft.iron_shovel": "Jernspade",
  "item.minecraft.iron_spear": "Jernspyd",
  "item.minecraft.iron_sword": "Jernsværd",
  "item.minecraft.item_frame": "Genstandsramme",
  "item.minecraft.jungle_boat": "Junglebåd",
  "item.minecraft.jungle_chest_boat": "Junglebåd med kiste",
  "item.minecraft.knowledge_book": "Kundskabsbog",
  "item.minecraft.lapis_lazuli": "Lapis lazuli",
  "item.minecraft.lava_bucket": "Lavaspand",
  "item.minecraft.lead": "Snor",
  "item.minecraft.leather": "Læder",
  "item.minecraft.leather_boots": "Læderstøvler",
  "item.minecraft.leather_chestplate": "Lædertunika",
  "item.minecraft.leather_helmet": "Læderhat",
  "item.minecraft.leather_horse_armor": "Læderhestearmering",
  "item.minecraft.leather_leggings": "Læderbukser",
  "item.minecraft.light_blue_bundle": "Lyseblåt bundt",
  "item.minecraft.light_blue_dye": "Lyseblåt farvestof",
  "item.minecraft.light_blue_harness": "Lyseblåt seletøj",
  "item.minecraft.light_gray_bundle": "Lysegråt bundt",
  "item.minecraft.light_gray_dye": "Lysegråt farvestof",
  "item.minecraft.light_gray_harness": "Lysegråt seletøj",
  "item.minecraft.lime_bundle": "Limegrønt bundt",
  "item.minecraft.lime_dye": "Limegrønt farvestof",
  "item.minecraft.lime_harness": "Limegrønt seletøj",
  "item.minecraft.lingering_potion": "Vedvarende eliksir",
  "item.minecraft.lingering_potion.effect.awkward": "Vedvarende akavet eliksir",
  "item.minecraft.lingering_potion.effect.empty": "Ulavelig vedvarende eliksir",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Vedvarende ildmodstandseliksir",
  "item.minecraft.lingering_potion.effect.harming": "Vedvarende skadeeliksir",
  "item.minecraft.lingering_potion.effect.healing": "Vedvarende helbredseliksir",
  "item.minecraft.lingering_potion.effect.infested": "Vedvarende infestationseliksir",
  "item.minecraft.lingering_potion.effect.invisibility": "Vedvarende usynlighedseliksir",
  "item.minecraft.lingering_potion.effect.leaping": "Vedvarende springeliksir",
  "item.minecraft.lingering_potion.effect.levitation": "Vedvarende levitationseliksir",
  "item.minecraft.lingering_potion.effect.luck": "Vedvarende heldeliksir",
  "item.minecraft.lingering_potion.effect.mundane": "Vedvarende banal eliksir",
  "item.minecraft.lingering_potion.effect.night_vision": "Vedvarende nattesynseliksir",
  "item.minecraft.lingering_potion.effect.oozing": "Vedvarende siveeliksir",
  "item.minecraft.lingering_potion.effect.poison": "Vedvarende gifteliksir",
  "item.minecraft.lingering_potion.effect.regeneration": "Vedvarende regenereringseliksir",
  "item.minecraft.lingering_potion.effect.slow_falling": "Vedvarende langsom fald eliksir",
  "item.minecraft.lingering_potion.effect.slowness": "Vedvarende langsomhedseliksir",
  "item.minecraft.lingering_potion.effect.strength": "Vedvarende styrkeeliksir",
  "item.minecraft.lingering_potion.effect.swiftness": "Vedvarende hurtighedseliksir",
  "item.minecraft.lingering_potion.effect.thick": "Vedvarende tyk eliksir",
  "item.minecraft.lingering_potion.effect.turtle_master": "Vedvarende skildpaddemestereliksir",
  "item.minecraft.lingering_potion.effect.water": "Vedvarende vandflaske",
  "item.minecraft.lingering_potion.effect.water_breathing": "Vedvarende gælleeliksir",
  "item.minecraft.lingering_potion.effect.weakness": "Vedvarende svaghedseliksir",
  "item.minecraft.lingering_potion.effect.weaving": "Vedvarende vævningseliksir",
  "item.minecraft.lingering_potion.effect.wind_charged": "Vedvarende vindladningseliksir",
  "item.minecraft.llama_spawn_egg": "Lama fremkaldningsæg",
  "item.minecraft.lodestone_compass": "Ledestenkompas",
  "item.minecraft.mace": "Kølle",
  "item.minecraft.magenta_bundle": "Magenta bundt",
  "item.minecraft.magenta_dye": "Magenta farvestof",
  "item.minecraft.magenta_harness": "Magenta seletøj",
  "item.minecraft.magma_cream": "Magmacreme",
  "item.minecraft.magma_cube_spawn_egg": "Magmakube fremkaldningsæg",
  "item.minecraft.mangrove_boat": "Mangrovebåd",
  "item.minecraft.mangrove_chest_boat": "Mangrovebåd med kiste",
  "item.minecraft.map": "Tomt kort",
  "item.minecraft.melon_seeds": "Vandmelonsfrø",
  "item.minecraft.melon_slice": "Melonskive",
  "item.minecraft.milk_bucket": "Mælkespand",
  "item.minecraft.minecart": "Minevogn",
  "item.minecraft.miner_pottery_shard": "Minearbejder keramikskår",
  "item.minecraft.miner_pottery_sherd": "Minearbejder keramikfragment",
  "item.minecraft.mojang_banner_pattern": "Bannermønster",
  "item.minecraft.mojang_banner_pattern.desc": "Ting",
  "item.minecraft.mojang_banner_pattern.new": "Ting bannermønster",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom fremkaldningsæg",
  "item.minecraft.mourner_pottery_shard": "Sørgende keramikskår",
  "item.minecraft.mourner_pottery_sherd": "Sørgende keramikfragment",
  "item.minecraft.mule_spawn_egg": "Muldyr fremkaldningsæg",
  "item.minecraft.mushroom_stew": "Svampestuvning",
  "item.minecraft.music_disc_11": "Musikplade",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Musikplade",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Musikplade",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Musikplade",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Musikplade",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Musikplade",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Musikplade",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Musikplade",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Musikplade",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Musikplade",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Musikplade",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Musikplade",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Musikplade",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Musikplade",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Musikplade",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Musikplade",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Musikplade",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Musikplade",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Musikplade",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Musikplade",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Musikplade",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Råt fårekød",
  "item.minecraft.name_tag": "Navneskilt",
  "item.minecraft.nautilus_shell": "Nautilskal",
  "item.minecraft.nautilus_spawn_egg": "Nautil fremkaldningsæg",
  "item.minecraft.nether_brick": "Nether-mursten",
  "item.minecraft.nether_star": "Nether-stjerne",
  "item.minecraft.nether_wart": "Nether-vorte",
  "item.minecraft.netherite_axe": "Netherritøkse",
  "item.minecraft.netherite_boots": "Netherritstøvler",
  "item.minecraft.netherite_chestplate": "Netherritbrystplade",
  "item.minecraft.netherite_helmet": "Netherrithjelm",
  "item.minecraft.netherite_hoe": "Netherritlugejern",
  "item.minecraft.netherite_horse_armor": "Netherrithestearmering",
  "item.minecraft.netherite_ingot": "Netherritbarre",
  "item.minecraft.netherite_leggings": "Netherritbukser",
  "item.minecraft.netherite_nautilus_armor": "Netherritnautilarmering",
  "item.minecraft.netherite_pickaxe": "Netherrithakke",
  "item.minecraft.netherite_scrap": "Netherittskrot",
  "item.minecraft.netherite_shovel": "Netherritspade",
  "item.minecraft.netherite_spear": "Netherritspyd",
  "item.minecraft.netherite_sword": "Netherritsværd",
  "item.minecraft.netherite_upgrade_smithing_template": "Smedeskabelon",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherritopgradering",
  "item.minecraft.oak_boat": "Egetræsbåd",
  "item.minecraft.oak_chest_boat": "Egetræsbåd med kiste",
  "item.minecraft.ocelot_spawn_egg": "Ozelot fremkaldningsæg",
  "item.minecraft.ominous_bottle": "Ildevarslende flaske",
  "item.minecraft.ominous_trial_key": "Ildevarslende prøvelsesnøgle",
  "item.minecraft.orange_bundle": "Orange bundt",
  "item.minecraft.orange_dye": "Orange farvestof",
  "item.minecraft.orange_harness": "Orange seletøj",
  "item.minecraft.painting": "Maleri",
  "item.minecraft.pale_oak_boat": "Bleg egetræsbåd",
  "item.minecraft.pale_oak_chest_boat": "Bleg egetræsbåd med kiste",
  "item.minecraft.panda_spawn_egg": "Panda fremkaldningsæg",
  "item.minecraft.paper": "Papir",
  "item.minecraft.parched_spawn_egg": "Udtørret skelet fremkaldningsæg",
  "item.minecraft.parrot_spawn_egg": "Papegøje fremkaldningsæg",
  "item.minecraft.phantom_membrane": "Fantommembran",
  "item.minecraft.phantom_spawn_egg": "Fantom fremkaldningsæg",
  "item.minecraft.pig_spawn_egg": "Gris fremkaldningsæg",
  "item.minecraft.piglin_banner_pattern": "Bannermønster",
  "item.minecraft.piglin_banner_pattern.desc": "Snude",
  "item.minecraft.piglin_banner_pattern.new": "Snude bannermønster",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin bølle fremkaldningsæg",
  "item.minecraft.piglin_spawn_egg": "Piglin fremkaldningsæg",
  "item.minecraft.pillager_spawn_egg": "Plyndrer fremkaldningsæg",
  "item.minecraft.pink_bundle": "Lyserødt bundt",
  "item.minecraft.pink_dye": "Lyserødt farvestof",
  "item.minecraft.pink_harness": "Lyserødt seletøj",
  "item.minecraft.pitcher_plant": "Kandeplante",
  "item.minecraft.pitcher_pod": "Kandefrø-skal",
  "item.minecraft.plenty_pottery_shard": "Rigdom keramikskår",
  "item.minecraft.plenty_pottery_sherd": "Rigdom keramikfragment",
  "item.minecraft.poisonous_potato": "Giftig kartoffel",
  "item.minecraft.polar_bear_spawn_egg": "Isbjørn fremkaldningsæg",
  "item.minecraft.popped_chorus_fruit": "Poppet omkvædsfrugt",
  "item.minecraft.porkchop": "Rå svinekotelet",
  "item.minecraft.potato": "Kartoffel",
  "item.minecraft.potion": "Eliksir",
  "item.minecraft.potion.effect.awkward": "Akavet eliksir",
  "item.minecraft.potion.effect.empty": "Ulavelig eliksir",
  "item.minecraft.potion.effect.fire_resistance": "Ildmodstandseliksir",
  "item.minecraft.potion.effect.harming": "Skadeeliksir",
  "item.minecraft.potion.effect.healing": "Helbredseliksir",
  "item.minecraft.potion.effect.infested": "Infestationseliksir",
  "item.minecraft.potion.effect.invisibility": "Usynlighedseliksir",
  "item.minecraft.potion.effect.leaping": "Springeliksir",
  "item.minecraft.potion.effect.levitation": "Levitationseliksir",
  "item.minecraft.potion.effect.luck": "Heldeliksir",
  "item.minecraft.potion.effect.mundane": "Banal eliksir",
  "item.minecraft.potion.effect.night_vision": "Nattesynseliksir",
  "item.minecraft.potion.effect.oozing": "Siveeliksir",
  "item.minecraft.potion.effect.poison": "Gifteliksir",
  "item.minecraft.potion.effect.regeneration": "Regenereringseliksir",
  "item.minecraft.potion.effect.slow_falling": "Langsom fald eliksir",
  "item.minecraft.potion.effect.slowness": "Langsomhedseliksir",
  "item.minecraft.potion.effect.strength": "Styrkeeliksir",
  "item.minecraft.potion.effect.swiftness": "Hurtighedseliksir",
  "item.minecraft.potion.effect.thick": "Tyk eliksir",
  "item.minecraft.potion.effect.turtle_master": "Skildpaddemestereliksir",
  "item.minecraft.potion.effect.water": "Vandflaske",
  "item.minecraft.potion.effect.water_breathing": "Gælleeliksir",
  "item.minecraft.potion.effect.weakness": "Svaghedseliksir",
  "item.minecraft.potion.effect.weaving": "Vævningseliksir",
  "item.minecraft.potion.effect.wind_charged": "Vindladningseliksir",
  "item.minecraft.pottery_shard_archer": "Bueskytte keramikskår",
  "item.minecraft.pottery_shard_arms_up": "Armene op keramikskår",
  "item.minecraft.pottery_shard_prize": "Præmie keramikskår",
  "item.minecraft.pottery_shard_skull": "Kranium keramikskår",
  "item.minecraft.powder_snow_bucket": "Pulversnespand",
  "item.minecraft.prismarine_crystals": "Prismarinekrystaller",
  "item.minecraft.prismarine_shard": "Prismarine-splint",
  "item.minecraft.prize_pottery_shard": "Præmie keramikskår",
  "item.minecraft.prize_pottery_sherd": "Præmie keramikfragment",
  "item.minecraft.pufferfish": "Kuglefisk",
  "item.minecraft.pufferfish_bucket": "Spand med kuglefisk",
  "item.minecraft.pufferfish_spawn_egg": "Kuglefisk fremkaldningsæg",
  "item.minecraft.pumpkin_pie": "Græskartærte",
  "item.minecraft.pumpkin_seeds": "Græskarfrø",
  "item.minecraft.purple_bundle": "Lilla bundt",
  "item.minecraft.purple_dye": "Lilla farvestof",
  "item.minecraft.purple_harness": "Lilla seletøj",
  "item.minecraft.quartz": "Nether-kvarts",
  "item.minecraft.rabbit": "Rå kanin",
  "item.minecraft.rabbit_foot": "Kaninfod",
  "item.minecraft.rabbit_hide": "Kaninskind",
  "item.minecraft.rabbit_spawn_egg": "Kanin fremkaldningsæg",
  "item.minecraft.rabbit_stew": "Kaninstuvning",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Opdrætter rustningspynt",
  "item.minecraft.ravager_spawn_egg": "Hærger fremkaldningsæg",
  "item.minecraft.raw_copper": "Rå kobber",
  "item.minecraft.raw_gold": "Rå guld",
  "item.minecraft.raw_iron": "Rå jern",
  "item.minecraft.recovery_compass": "Genfindingskompas",
  "item.minecraft.red_bundle": "Rødt bundt",
  "item.minecraft.red_dye": "Rødt farvestof",
  "item.minecraft.red_harness": "Rødt seletøj",
  "item.minecraft.redstone": "Redstonestøv",
  "item.minecraft.resin_brick": "Harpiksmursten",
  "item.minecraft.resin_clump": "Harpiksklump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ribben rustningspynt",
  "item.minecraft.rotten_flesh": "Råddent kød",
  "item.minecraft.saddle": "Sadel",
  "item.minecraft.salmon": "Rå laks",
  "item.minecraft.salmon_bucket": "Spand med laks",
  "item.minecraft.salmon_spawn_egg": "Laks fremkaldningsæg",
  "item.minecraft.scrape_pottery_sherd": "Økse keramikfragment",
  "item.minecraft.scute": "Skæl",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Vagt rustningspynt",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Formgiver rustningspynt",
  "item.minecraft.sheaf_pottery_shard": "Hvede keramikskår",
  "item.minecraft.sheaf_pottery_sherd": "Hvede keramikfragment",
  "item.minecraft.shears": "Saks",
  "item.minecraft.sheep_spawn_egg": "Får fremkaldningsæg",
  "item.minecraft.shelter_pottery_shard": "Ly keramikskår",
  "item.minecraft.shelter_pottery_sherd": "Ly keramikfragment",
  "item.minecraft.shield": "Skjold",
  "item.minecraft.shield.black": "Sort skjold",
  "item.minecraft.shield.blue": "Blåt skjold",
  "item.minecraft.shield.brown": "Brunt skjold",
  "item.minecraft.shield.cyan": "Turkis skjold",
  "item.minecraft.shield.gray": "Gråt skjold",
  "item.minecraft.shield.green": "Grønt skjold",
  "item.minecraft.shield.light_blue": "Lyseblåt skjold",
  "item.minecraft.shield.light_gray": "Lysegråt skjold",
  "item.minecraft.shield.lime": "Limegrønt skjold",
  "item.minecraft.shield.magenta": "Magenta skjold",
  "item.minecraft.shield.orange": "Orange skjold",
  "item.minecraft.shield.pink": "Lyserødt skjold",
  "item.minecraft.shield.purple": "Lilla skjold",
  "item.minecraft.shield.red": "Rødt skjold",
  "item.minecraft.shield.white": "Hvidt skjold",
  "item.minecraft.shield.yellow": "Gult skjold",
  "item.minecraft.shulker_shell": "Shulkerskal",
  "item.minecraft.shulker_spawn_egg": "Shulker fremkaldningsæg",
  "item.minecraft.sign": "Skilt",
  "item.minecraft.silence_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Stilhed rustningspynt",
  "item.minecraft.silverfish_spawn_egg": "Sølvfisk fremkaldningsæg",
  "item.minecraft.skeleton_horse_spawn_egg": "Skelethest fremkaldningsæg",
  "item.minecraft.skeleton_spawn_egg": "Skelet fremkaldningsæg",
  "item.minecraft.skull_banner_pattern": "Bannermønster",
  "item.minecraft.skull_banner_pattern.desc": "Kraniumsymbol",
  "item.minecraft.skull_banner_pattern.new": "Kraniumsymbol bannermønster",
  "item.minecraft.skull_pottery_shard": "Kranium keramikskår",
  "item.minecraft.skull_pottery_sherd": "Kranium keramikfragment",
  "item.minecraft.slime_ball": "Slimbold",
  "item.minecraft.slime_spawn_egg": "Slimklump fremkaldningsæg",
  "item.minecraft.smithing_template": "Smedeskabelon",
  "item.minecraft.smithing_template.applies_to": "Gælder for:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Tilføj barre eller krystal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Rustning",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Tilføj et stykke rustning",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Barrer & krystaller",
  "item.minecraft.smithing_template.ingredients": "Ingredienser:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Tilføj netherritbarre",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantudstyr",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Tilføj diamantrustning, -våben eller -værktøj",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherritbarre",
  "item.minecraft.smithing_template.upgrade": "Opgradering: ",
  "item.minecraft.sniffer_spawn_egg": "Sniffer fremkaldningsæg",
  "item.minecraft.snort_pottery_shard": "Prust keramikskår",
  "item.minecraft.snort_pottery_sherd": "Prust keramikfragment",
  "item.minecraft.snout_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snude rustningspynt",
  "item.minecraft.snow_golem_spawn_egg": "Snemand fremkaldningsæg",
  "item.minecraft.snowball": "Snebold",
  "item.minecraft.spectral_arrow": "Spektral pil",
  "item.minecraft.spider_eye": "Edderkoppeøje",
  "item.minecraft.spider_spawn_egg": "Edderkop fremkaldningsæg",
  "item.minecraft.spire_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spir rustningspynt",
  "item.minecraft.splash_potion": "Sprøjtende eliksir",
  "item.minecraft.splash_potion.effect.awkward": "Akavet sprøjtende eliksir",
  "item.minecraft.splash_potion.effect.empty": "Ulavelig sprøjtende eliksir",
  "item.minecraft.splash_potion.effect.fire_resistance": "Sprøjtende ildmodstandseliksir",
  "item.minecraft.splash_potion.effect.harming": "Sprøjtende skadeeliksir",
  "item.minecraft.splash_potion.effect.healing": "Sprøjtende helbredseliksir",
  "item.minecraft.splash_potion.effect.infested": "Sprøjtende infestationseliksir",
  "item.minecraft.splash_potion.effect.invisibility": "Sprøjtende usynlighedseliksir",
  "item.minecraft.splash_potion.effect.leaping": "Sprøjtende springeliksir",
  "item.minecraft.splash_potion.effect.levitation": "Sprøjtende levitationseliksir",
  "item.minecraft.splash_potion.effect.luck": "Sprøjtende heldeliksir",
  "item.minecraft.splash_potion.effect.mundane": "Banal sprøjtende eliksir",
  "item.minecraft.splash_potion.effect.night_vision": "Sprøjtende nattesynseliksir",
  "item.minecraft.splash_potion.effect.oozing": "Sprøjtende siveeliksir",
  "item.minecraft.splash_potion.effect.poison": "Sprøjtende gifteliksir",
  "item.minecraft.splash_potion.effect.regeneration": "Sprøjtende regenereringseliksir",
  "item.minecraft.splash_potion.effect.slow_falling": "Sprøjtene langsom fald eliksir",
  "item.minecraft.splash_potion.effect.slowness": "Sprøjtende langsomhedseliksir",
  "item.minecraft.splash_potion.effect.strength": "Sprøjtende styrkeeliksir",
  "item.minecraft.splash_potion.effect.swiftness": "Sprøjtende hurtighedseliksir",
  "item.minecraft.splash_potion.effect.thick": "Tyk sprøjtende eliksir",
  "item.minecraft.splash_potion.effect.turtle_master": "Sprøjtende skildpaddemestereliksir",
  "item.minecraft.splash_potion.effect.water": "Sprøjtende vandflaske",
  "item.minecraft.splash_potion.effect.water_breathing": "Sprøjtende gælleeliksir",
  "item.minecraft.splash_potion.effect.weakness": "Sprøjtende svaghedseliksir",
  "item.minecraft.splash_potion.effect.weaving": "Spøjtende vævningseliksir",
  "item.minecraft.splash_potion.effect.wind_charged": "Sprøjtende vindladningseliksir",
  "item.minecraft.spruce_boat": "Granbåd",
  "item.minecraft.spruce_chest_boat": "Granbåd med kiste",
  "item.minecraft.spyglass": "Kikkert",
  "item.minecraft.squid_spawn_egg": "Blæksprutte fremkaldningsæg",
  "item.minecraft.stick": "Pind",
  "item.minecraft.stone_axe": "Stenøkse",
  "item.minecraft.stone_hoe": "Stenlugejern",
  "item.minecraft.stone_pickaxe": "Stenhakke",
  "item.minecraft.stone_shovel": "Stenspade",
  "item.minecraft.stone_spear": "Stenspyd",
  "item.minecraft.stone_sword": "Stensværd",
  "item.minecraft.stray_spawn_egg": "Omstrejfer fremkaldningsæg",
  "item.minecraft.strider_spawn_egg": "Lavavandrer fremkaldningsæg",
  "item.minecraft.string": "Tråd",
  "item.minecraft.sugar": "Sukker",
  "item.minecraft.suspicious_stew": "Mistænkelig stuvning",
  "item.minecraft.sweet_berries": "Søde bær",
  "item.minecraft.tadpole_bucket": "Spand med haletudser",
  "item.minecraft.tadpole_spawn_egg": "Haletudse fremkaldningsæg",
  "item.minecraft.tide_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tidevand rustningspynt",
  "item.minecraft.tipped_arrow": "Dyppet pil",
  "item.minecraft.tipped_arrow.effect.awkward": "Dyppet pil",
  "item.minecraft.tipped_arrow.effect.empty": "Ulavelig dyppet pil",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Pil af ildmodstand",
  "item.minecraft.tipped_arrow.effect.harming": "Pil af skade",
  "item.minecraft.tipped_arrow.effect.healing": "Pil af helbred",
  "item.minecraft.tipped_arrow.effect.infested": "Pil af infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Pil af usynlighed",
  "item.minecraft.tipped_arrow.effect.leaping": "Pil af superhop",
  "item.minecraft.tipped_arrow.effect.levitation": "Pil af Levitation",
  "item.minecraft.tipped_arrow.effect.luck": "Pil af lykke",
  "item.minecraft.tipped_arrow.effect.mundane": "Dyppet pil",
  "item.minecraft.tipped_arrow.effect.night_vision": "Pil af nattesyn",
  "item.minecraft.tipped_arrow.effect.oozing": "Pil af sivning",
  "item.minecraft.tipped_arrow.effect.poison": "Pil af gift",
  "item.minecraft.tipped_arrow.effect.regeneration": "Pil af regenerering",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Pil af langsom fald",
  "item.minecraft.tipped_arrow.effect.slowness": "Pil af langsomhed",
  "item.minecraft.tipped_arrow.effect.strength": "Pil af styrke",
  "item.minecraft.tipped_arrow.effect.swiftness": "Pil af hurtighed",
  "item.minecraft.tipped_arrow.effect.thick": "Dyppet pil",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Pil af skildpaddemester",
  "item.minecraft.tipped_arrow.effect.water": "Sprøjtende pil",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Pil af gæller",
  "item.minecraft.tipped_arrow.effect.weakness": "Pil af svaghed",
  "item.minecraft.tipped_arrow.effect.weaving": "Pil af vævning",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Pil af vindladning",
  "item.minecraft.tnt_minecart": "Minevogn med TNT",
  "item.minecraft.torchflower_seeds": "Fakkelblomstfrø",
  "item.minecraft.totem_of_undying": "Totem af udødelighed",
  "item.minecraft.trader_llama_spawn_egg": "Forhandler lama fremkaldningsæg",
  "item.minecraft.trial_key": "Prøvelsesnøgle",
  "item.minecraft.trident": "Trefork",
  "item.minecraft.tropical_fish": "Tropisk fisk",
  "item.minecraft.tropical_fish_bucket": "Spand med tropisk fisk",
  "item.minecraft.tropical_fish_spawn_egg": "Tropisk fisk fremkaldningsæg",
  "item.minecraft.turtle_helmet": "Skildpaddeskjold",
  "item.minecraft.turtle_scute": "Skildpaddeskæl",
  "item.minecraft.turtle_spawn_egg": "Skildpadde fremkaldningsæg",
  "item.minecraft.vex_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex rustningspynt",
  "item.minecraft.vex_spawn_egg": "Vex fremkaldningsæg",
  "item.minecraft.villager_spawn_egg": "Landsbyboer fremkaldningsæg",
  "item.minecraft.vindicator_spawn_egg": "Hævner fremkaldningsæg",
  "item.minecraft.wandering_trader_spawn_egg": "Handelsrejsende fremkaldningsæg",
  "item.minecraft.ward_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward rustningspynt",
  "item.minecraft.warden_spawn_egg": "Vogter fremkaldningsæg",
  "item.minecraft.warped_fungus_on_a_stick": "Forskruet svamp på en pind",
  "item.minecraft.water_bucket": "Vandspand",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Vejfinder rustningspynt",
  "item.minecraft.wheat": "Hvede",
  "item.minecraft.wheat_seeds": "Hvede frø",
  "item.minecraft.white_bundle": "Hvidt bundt",
  "item.minecraft.white_dye": "Hvidt farvestof",
  "item.minecraft.white_harness": "Hvidt seletøj",
  "item.minecraft.wild_armor_trim_smithing_template": "Smedeskabelon",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Vild rustningspynt",
  "item.minecraft.wind_charge": "Vindladning",
  "item.minecraft.witch_spawn_egg": "Heks fremkaldningsæg",
  "item.minecraft.wither_skeleton_spawn_egg": "Witherskelet fremkaldningsæg",
  "item.minecraft.wither_spawn_egg": "Wither fremkaldningsæg",
  "item.minecraft.wolf_armor": "Ulverustning",
  "item.minecraft.wolf_spawn_egg": "Ulv fremkaldningsæg",
  "item.minecraft.wooden_axe": "Træøkse",
  "item.minecraft.wooden_hoe": "Trælugejern",
  "item.minecraft.wooden_pickaxe": "Træhakke",
  "item.minecraft.wooden_shovel": "Træspade",
  "item.minecraft.wooden_spear": "Træspyd",
  "item.minecraft.wooden_sword": "Træsværd",
  "item.minecraft.writable_book": "Bog og fjerpen",
  "item.minecraft.written_book": "Skrevet bog",
  "item.minecraft.yellow_bundle": "Gult bundt",
  "item.minecraft.yellow_dye": "Gult farvestof",
  "item.minecraft.yellow_harness": "Gult seletøj",
  "item.minecraft.zoglin_spawn_egg": "Zoglin fremkaldningsæg",
  "item.minecraft.zombie_horse_spawn_egg": "Zombiehest fremkaldningsæg",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombienautil fremkaldningsæg",
  "item.minecraft.zombie_spawn_egg": "Zombie fremkaldningsæg",
  "item.minecraft.zombie_villager_spawn_egg": "Zombielandsbyboer fremkaldningsæg",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombificeret piglin fremkaldningsæg"
}
export const da_dk = items; 
